
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$t, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$d = Array.isArray;
function $13c40c34b78c8ee2$var$w(n, l) {
    for(var t in l)n[t] = l[t];
    return n;
}
function $13c40c34b78c8ee2$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, t, u) {
    var i, r, o, e = {};
    for(o in t)"key" == o ? i = t[o] : "ref" == o ? r = t[o] : e[o] = t[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : u), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$m(l, e, i, r, null);
}
function $13c40c34b78c8ee2$var$m(n, u, i, r, o) {
    var e = {
        type: n,
        props: u,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$t : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$S(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$S(n.__, n.__i + 1) : null;
    for(var t; l < n.__k.length; l++)if (null != (t = n.__k[l]) && null != t.__e) return t.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$S(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, t;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (t = n.__k[l]) && null != t.__e) {
            n.__e = n.__c.base = t.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$r !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$r = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$o)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    for(var n, t, u, r, o, f, c, s = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > s && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), s = $13c40c34b78c8ee2$var$i.length, n.__d && (u = void 0, o = (r = (t = n).__v).__e, f = [], c = [], t.__P && ((u = $13c40c34b78c8ee2$var$w({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(u), $13c40c34b78c8ee2$var$O(t.__P, u, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $13c40c34b78c8ee2$var$S(r) : o, !!(32 & r.__u), c), u.__v = r.__v, u.__.__k[u.__i] = u, $13c40c34b78c8ee2$var$z(f, u, c), u.__e != o && $13c40c34b78c8ee2$var$C(u)));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$I(n, l, t, u, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _ = u && u.__k || $13c40c34b78c8ee2$var$v, m = l.length;
    for(f = $13c40c34b78c8ee2$var$P(t, l, _, f, m), a = 0; a < m; a++)null != (y = t.__k[a]) && (h = -1 === y.__i ? $13c40c34b78c8ee2$var$p : _[y.__i] || $13c40c34b78c8ee2$var$p, y.__i = a, g = $13c40c34b78c8ee2$var$O(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c40c34b78c8ee2$var$q(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 4 & y.__u || h.__k === y.__k ? f = $13c40c34b78c8ee2$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return t.__e = w, f;
}
function $13c40c34b78c8ee2$var$P(n, l, t, u, i) {
    var r, o, e, f, c, s = t.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $13c40c34b78c8ee2$var$m(null, o, null, null, null) : $13c40c34b78c8ee2$var$d(o) ? $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? $13c40c34b78c8ee2$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 !== (c = o.__i = $13c40c34b78c8ee2$var$L(o, t, f, a)) && (a--, (e = t[c]) && (e.__u |= 2)), null == e || null === e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = t[r]) && 0 == (2 & e.__u) && (e.__e == u && (u = $13c40c34b78c8ee2$var$S(e)), $13c40c34b78c8ee2$var$B(e, e));
    return u;
}
function $13c40c34b78c8ee2$var$A(n, l, t) {
    var u, i;
    if ("function" == typeof n.type) {
        for(u = n.__k, i = 0; u && i < u.length; i++)u[i] && (u[i].__ = n, l = $13c40c34b78c8ee2$var$A(u[i], l, t));
        return l;
    }
    n.__e != l && (l && n.type && !t.contains(l) && (l = $13c40c34b78c8ee2$var$S(n)), t.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$d(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, t, u) {
    var i, r, o = n.key, e = n.type, f = l[t];
    if (null === f && null == n.key || f && o == f.key && e === f.type && 0 == (2 & f.__u)) return t;
    if (u > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = t - 1, r = t + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return r;
            r++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, t) {
    "-" == l[0] ? n.setProperty(l, null == t ? "" : t) : n[l] = null == t ? "" : "number" != typeof t || $13c40c34b78c8ee2$var$y.test(l) ? t : t + "px";
}
function $13c40c34b78c8ee2$var$j(n, l, t, u, i) {
    var r;
    n: if ("style" == l) {
        if ("string" == typeof t) n.style.cssText = t;
        else {
            if ("string" == typeof u && (n.style.cssText = u = ""), u) for(l in u)t && l in t || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (t) for(l in t)u && t[l] === u[l] || $13c40c34b78c8ee2$var$T(n.style, l, t[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c40c34b78c8ee2$var$f, "$1")), l = l.toLowerCase() in n || "onFocusOut" == l || "onFocusIn" == l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = t, t ? u ? t.t = u.t : (t.t = $13c40c34b78c8ee2$var$c, n.addEventListener(l, r ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, r)) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == t ? "" : t;
            break n;
        } catch (n) {}
        "function" == typeof t || (null == t || !1 === t && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == t ? "" : t));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(t) {
        if (this.l) {
            var u = this.l[t.type + n];
            if (null == t.u) t.u = $13c40c34b78c8ee2$var$c++;
            else if (t.u < u.t) return;
            return u($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(t) : t);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, t, u, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = t.type;
    if (void 0 !== t.constructor) return null;
    128 & u.__u && (c = !!(32 & u.__u), o = [
        f = t.__e = u.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(t);
    n: if ("function" == typeof j) try {
        if (b = t.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, u.__c ? m = (h = t.__c = u.__c).__ = h.__E : (S ? t.__c = h = new j(b, M) : (t.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $13c40c34b78c8ee2$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$w({}, h.__s)), $13c40c34b78c8ee2$var$w(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = t, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || t.__v == u.__v)) {
                for(t.__v != u.__v && (h.props = b, h.state = h.__s, h.__d = !1), t.__e = u.__e, t.__k = u.__k, t.__k.some(function(n) {
                    n && (n.__ = t);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(t), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(t), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$w($13c40c34b78c8ee2$var$w({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key && (L = $13c40c34b78c8ee2$var$N(a.props.children)), f = $13c40c34b78c8ee2$var$I(n, $13c40c34b78c8ee2$var$d(L) ? L : [
            L
        ], t, u, i, r, o, e, f, c, s), h.base = t.__e, t.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (t.__v = null, c || null != o) {
            if (n.then) {
                for(t.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, t.__e = f;
            } else for(T = o.length; T--;)$13c40c34b78c8ee2$var$g(o[T]);
        } else t.__e = u.__e, t.__k = u.__k;
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t, u);
    }
    else null == o && t.__v == u.__v ? (t.__k = u.__k, t.__e = u.__e) : f = t.__e = $13c40c34b78c8ee2$var$V(u.__e, t, u, i, r, o, e, c, s);
    return (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(t), 128 & t.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$z(n, t, u) {
    for(var i = 0; i < u.length; i++)$13c40c34b78c8ee2$var$q(u[i], u[++i], u[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(t, n), n.some(function(t) {
        try {
            n = t.__h, t.__h = [], n.some(function(n) {
                n.call(t);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$N(n) {
    return "object" != typeof n || null == n ? n : $13c40c34b78c8ee2$var$d(n) ? n.map($13c40c34b78c8ee2$var$N) : $13c40c34b78c8ee2$var$w({}, n);
}
function $13c40c34b78c8ee2$var$V(t, u, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props, k = u.props, x = u.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            t = w, e[a] = null;
            break;
        }
    }
    if (null == t) {
        if (null == x) return document.createTextNode(k);
        t = document.createElementNS(o, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(u, e), c = !1), e = null;
    }
    if (null === x) b === k || c && t.data === k || (t.data = k);
    else {
        if (e = e && $13c40c34b78c8ee2$var$n.call(t.childNodes), b = i.props || $13c40c34b78c8ee2$var$p, !c && null != e) for(b = {}, a = 0; a < t.attributes.length; a++)b[(w = t.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$j(t, a, null, w, o);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $13c40c34b78c8ee2$var$j(t, a, w, b[a], o);
        if (h) c || v && (h.__html === v.__html || h.__html === t.innerHTML) || (t.innerHTML = h.__html), u.__k = [];
        else if (v && (t.innerHTML = ""), $13c40c34b78c8ee2$var$I("template" === u.type ? t.content : t, $13c40c34b78c8ee2$var$d(y) ? y : [
            y
        ], u, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c40c34b78c8ee2$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? t.removeAttribute("value") : void 0 !== _ && (_ !== t[a] || "progress" == x && !_ || "option" == x && _ !== b[a]) && $13c40c34b78c8ee2$var$j(t, a, _, b[a], o), a = "checked", void 0 !== m && m !== t[a] && $13c40c34b78c8ee2$var$j(t, a, m, b[a], o));
    }
    return t;
}
function $13c40c34b78c8ee2$var$q(n, t, u) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == t || (n.__u = n(t));
        } else n.current = t;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
    }
}
function $13c40c34b78c8ee2$var$B(n, t, u) {
    var i, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$q(i, null, t)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c40c34b78c8ee2$var$B(i[r], t, u || "function" != typeof n.type);
    u || $13c40c34b78c8ee2$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$D(n, l, t) {
    return this.constructor(n, t);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(t, u, i) {
    var r, o, e, f;
    u == document && (u = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(t, u), o = (r = "function" == typeof i) ? null : i && i.__k || u.__k, e = [], f = [], $13c40c34b78c8ee2$var$O(u, t = (!r && i || u).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        t
    ]), o || $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$p, u.namespaceURI, !r && i ? [
        i
    ] : o ? null : u.firstChild ? $13c40c34b78c8ee2$var$n.call(u.childNodes) : null, e, !r && i ? i : o ? o.__e : u.firstChild, r, f), $13c40c34b78c8ee2$var$z(e, t, f);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, t, u) {
    var i, r, o, e, f = $13c40c34b78c8ee2$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), t)"key" == o ? i = t[o] : "ref" == o ? r = t[o] : f[o] = void 0 === t[o] && void 0 !== e ? e[o] : t[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : u), $13c40c34b78c8ee2$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var t, u;
        return this.getChildContext || (t = new Set, (u = {})[l.__c] = this, this.getChildContext = function() {
            return u;
        }, this.componentWillUnmount = function() {
            t = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value !== n.value && t.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$M(n);
            });
        }, this.sub = function(n) {
            t.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                t && t.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, t, u) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, u || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$t = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var t;
    t = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$w({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$w({}, t), this.props)), n && $13c40c34b78c8ee2$var$w(t, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$f = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$c = 0, $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$a = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$h = 0;




var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2), $204a33a7557cbbd0$var$e = $204a33a7557cbbd0$var$c.__b, $204a33a7557cbbd0$var$a = $204a33a7557cbbd0$var$c.__r, $204a33a7557cbbd0$var$v = $204a33a7557cbbd0$var$c.diffed, $204a33a7557cbbd0$var$l = $204a33a7557cbbd0$var$c.__c, $204a33a7557cbbd0$var$m = $204a33a7557cbbd0$var$c.unmount, $204a33a7557cbbd0$var$s = $204a33a7557cbbd0$var$c.__;
function $204a33a7557cbbd0$var$p(n, t) {
    $204a33a7557cbbd0$var$c.__h && $204a33a7557cbbd0$var$c.__h($204a33a7557cbbd0$var$r, n, $204a33a7557cbbd0$var$o || t), $204a33a7557cbbd0$var$o = 0;
    var u = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$D, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $204a33a7557cbbd0$var$r.__f = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(n, u) {
    var i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 3);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__H.__h.push(i));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(n, u) {
    var i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 4);
    !$204a33a7557cbbd0$var$c.__s && $204a33a7557cbbd0$var$C(i.__H, u) && (i.__ = n, i.u = u, $204a33a7557cbbd0$var$r.__h.push(i));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(n, t) {
    $204a33a7557cbbd0$var$c.useDebugValue && $204a33a7557cbbd0$var$c.useDebugValue(t ? t(n) : n);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$p($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$j() {
    for(var n; n = $204a33a7557cbbd0$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($204a33a7557cbbd0$var$z), n.__H.__h.forEach($204a33a7557cbbd0$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $204a33a7557cbbd0$var$c.__e(t, n.__v);
    }
}
$204a33a7557cbbd0$var$c.__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, $204a33a7557cbbd0$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $204a33a7557cbbd0$var$s && $204a33a7557cbbd0$var$s(n, t);
}, $204a33a7557cbbd0$var$c.__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$z), i.__h.forEach($204a33a7557cbbd0$var$B), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, $204a33a7557cbbd0$var$c.diffed = function(n) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(t) && $204a33a7557cbbd0$var$i === $204a33a7557cbbd0$var$c.requestAnimationFrame || (($204a33a7557cbbd0$var$i = $204a33a7557cbbd0$var$c.requestAnimationFrame) || $204a33a7557cbbd0$var$w)($204a33a7557cbbd0$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, $204a33a7557cbbd0$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($204a33a7557cbbd0$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $204a33a7557cbbd0$var$c.__e(r, n.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(n, t);
}, $204a33a7557cbbd0$var$c.unmount = function(n) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $204a33a7557cbbd0$var$c.__e(t, r.__v));
};
var $204a33a7557cbbd0$var$k = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$k && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$z(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$B(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


/*!
 Based on ndef.parser, by Raphael Graf(r@undefined.ch)
 http://www.undefined.ch/mparser/index.html

 Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)

 You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
 to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
 but don't feel like you have to let me know or ask permission.
*/ var $57c046643b8fb398$export$5b94d32c6cd7452d = 'INUMBER';
var $57c046643b8fb398$export$6cd938543ae18fbf = 'IOP1';
var $57c046643b8fb398$export$dc35c38d7a9a4dc9 = 'IOP2';
var $57c046643b8fb398$export$89691300e9f21d05 = 'IOP3';
var $57c046643b8fb398$export$c3edb8ae35b9c3a5 = 'IVAR';
var $57c046643b8fb398$export$b48ccc1026b7e1a9 = 'IVARNAME';
var $57c046643b8fb398$export$89c431167cf161a1 = 'IFUNCALL';
var $57c046643b8fb398$export$5fbc192a0fb284ee = 'IFUNDEF';
var $57c046643b8fb398$export$8c955dcbad9059de = 'IEXPR';
var $57c046643b8fb398$export$18e665f85cdda0f0 = 'IEXPREVAL';
var $57c046643b8fb398$export$b6338d0dcc87172d = 'IMEMBER';
var $57c046643b8fb398$export$1d3fc08acb362c1c = 'IENDSTATEMENT';
var $57c046643b8fb398$export$ab9692aa28ce44b7 = 'IARRAY';
function $57c046643b8fb398$export$f361d4ae234b90f4(type, value) {
    this.type = type;
    this.value = value !== undefined && value !== null ? value : 0;
}
$57c046643b8fb398$export$f361d4ae234b90f4.prototype.toString = function() {
    switch(this.type){
        case $57c046643b8fb398$export$5b94d32c6cd7452d:
        case $57c046643b8fb398$export$6cd938543ae18fbf:
        case $57c046643b8fb398$export$dc35c38d7a9a4dc9:
        case $57c046643b8fb398$export$89691300e9f21d05:
        case $57c046643b8fb398$export$c3edb8ae35b9c3a5:
        case $57c046643b8fb398$export$b48ccc1026b7e1a9:
        case $57c046643b8fb398$export$1d3fc08acb362c1c:
            return this.value;
        case $57c046643b8fb398$export$89c431167cf161a1:
            return 'CALL ' + this.value;
        case $57c046643b8fb398$export$5fbc192a0fb284ee:
            return 'DEF ' + this.value;
        case $57c046643b8fb398$export$ab9692aa28ce44b7:
            return 'ARRAY ' + this.value;
        case $57c046643b8fb398$export$b6338d0dcc87172d:
            return '.' + this.value;
        default:
            return 'Invalid Instruction';
    }
};
function $57c046643b8fb398$export$d2f4ceacf005edb(value) {
    return new $57c046643b8fb398$export$f361d4ae234b90f4($57c046643b8fb398$export$6cd938543ae18fbf, value);
}
function $57c046643b8fb398$export$f2bdb78bb4179fd7(value) {
    return new $57c046643b8fb398$export$f361d4ae234b90f4($57c046643b8fb398$export$dc35c38d7a9a4dc9, value);
}
function $57c046643b8fb398$export$a7185502bcf21610(value) {
    return new $57c046643b8fb398$export$f361d4ae234b90f4($57c046643b8fb398$export$89691300e9f21d05, value);
}


function $af6574e1899c2e98$export$2e2bcd8739ae039(tokens, unaryOps, binaryOps, ternaryOps, values) {
    var nstack = [];
    var newexpression = [];
    var n1, n2, n3;
    var f;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === (0, $57c046643b8fb398$export$5b94d32c6cd7452d) || type === (0, $57c046643b8fb398$export$b48ccc1026b7e1a9)) {
            if (Array.isArray(item.value)) nstack.push.apply(nstack, $af6574e1899c2e98$export$2e2bcd8739ae039(item.value.map(function(x) {
                return new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), x);
            }).concat(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$ab9692aa28ce44b7), item.value.length)), unaryOps, binaryOps, ternaryOps, values));
            else nstack.push(item);
        } else if (type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5) && values.hasOwnProperty(item.value)) {
            item = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), values[item.value]);
            nstack.push(item);
        } else if (type === (0, $57c046643b8fb398$export$dc35c38d7a9a4dc9) && nstack.length > 1) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = binaryOps[item.value];
            item = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), f(n1.value, n2.value));
            nstack.push(item);
        } else if (type === (0, $57c046643b8fb398$export$89691300e9f21d05) && nstack.length > 2) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === '?') nstack.push(n1.value ? n2.value : n3.value);
            else {
                f = ternaryOps[item.value];
                item = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), f(n1.value, n2.value, n3.value));
                nstack.push(item);
            }
        } else if (type === (0, $57c046643b8fb398$export$6cd938543ae18fbf) && nstack.length > 0) {
            n1 = nstack.pop();
            f = unaryOps[item.value];
            item = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), f(n1.value));
            nstack.push(item);
        } else if (type === (0, $57c046643b8fb398$export$8c955dcbad9059de)) {
            while(nstack.length > 0)newexpression.push(nstack.shift());
            newexpression.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), $af6574e1899c2e98$export$2e2bcd8739ae039(item.value, unaryOps, binaryOps, ternaryOps, values)));
        } else if (type === (0, $57c046643b8fb398$export$b6338d0dcc87172d) && nstack.length > 0) {
            n1 = nstack.pop();
            nstack.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), n1.value[item.value]));
        } else {
            while(nstack.length > 0)newexpression.push(nstack.shift());
            newexpression.push(item);
        }
    }
    while(nstack.length > 0)newexpression.push(nstack.shift());
    return newexpression;
}



function $093b31fd7ff23812$export$2e2bcd8739ae039(tokens, variable, expr) {
    var newexpression = [];
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5) && item.value === variable) for(var j = 0; j < expr.tokens.length; j++){
            var expritem = expr.tokens[j];
            var replitem;
            if (expritem.type === (0, $57c046643b8fb398$export$6cd938543ae18fbf)) replitem = (0, $57c046643b8fb398$export$d2f4ceacf005edb)(expritem.value);
            else if (expritem.type === (0, $57c046643b8fb398$export$dc35c38d7a9a4dc9)) replitem = (0, $57c046643b8fb398$export$f2bdb78bb4179fd7)(expritem.value);
            else if (expritem.type === (0, $57c046643b8fb398$export$89691300e9f21d05)) replitem = (0, $57c046643b8fb398$export$a7185502bcf21610)(expritem.value);
            else replitem = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)(expritem.type, expritem.value);
            newexpression.push(replitem);
        }
        else if (type === (0, $57c046643b8fb398$export$8c955dcbad9059de)) newexpression.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), $093b31fd7ff23812$export$2e2bcd8739ae039(item.value, variable, expr)));
        else newexpression.push(item);
    }
    return newexpression;
}



function $4c16e2382cfc2cd9$export$2e2bcd8739ae039(tokens, expr, values) {
    var nstack = [];
    var n1, n2, n3;
    var f, args, argCount;
    if ($4c16e2382cfc2cd9$var$isExpressionEvaluator(tokens)) return $4c16e2382cfc2cd9$var$resolveExpression(tokens, values);
    var numTokens = tokens.length;
    for(var i = 0; i < numTokens; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === (0, $57c046643b8fb398$export$5b94d32c6cd7452d) || type === (0, $57c046643b8fb398$export$b48ccc1026b7e1a9)) nstack.push(item.value);
        else if (type === (0, $57c046643b8fb398$export$dc35c38d7a9a4dc9)) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === 'and') nstack.push(n1 ? !!$4c16e2382cfc2cd9$export$2e2bcd8739ae039(n2, expr, values) : false);
            else if (item.value === 'or') nstack.push(n1 ? true : !!$4c16e2382cfc2cd9$export$2e2bcd8739ae039(n2, expr, values));
            else if (item.value === '=') {
                f = expr.binaryOps[item.value];
                nstack.push(f(n1, $4c16e2382cfc2cd9$export$2e2bcd8739ae039(n2, expr, values), values));
            } else {
                f = expr.binaryOps[item.value];
                nstack.push(f($4c16e2382cfc2cd9$var$resolveExpression(n1, values), $4c16e2382cfc2cd9$var$resolveExpression(n2, values)));
            }
        } else if (type === (0, $57c046643b8fb398$export$89691300e9f21d05)) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === '?') nstack.push($4c16e2382cfc2cd9$export$2e2bcd8739ae039(n1 ? n2 : n3, expr, values));
            else {
                f = expr.ternaryOps[item.value];
                nstack.push(f($4c16e2382cfc2cd9$var$resolveExpression(n1, values), $4c16e2382cfc2cd9$var$resolveExpression(n2, values), $4c16e2382cfc2cd9$var$resolveExpression(n3, values)));
            }
        } else if (type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5)) {
            if (/^__proto__|prototype|constructor$/.test(item.value)) throw new Error('prototype access detected');
            if (item.value in expr.functions) nstack.push(expr.functions[item.value]);
            else if (item.value in expr.unaryOps && expr.parser.isOperatorEnabled(item.value)) nstack.push(expr.unaryOps[item.value]);
            else {
                var v = values[item.value];
                if (v !== undefined) nstack.push(v);
                else throw new Error('undefined variable: ' + item.value);
            }
        } else if (type === (0, $57c046643b8fb398$export$6cd938543ae18fbf)) {
            n1 = nstack.pop();
            f = expr.unaryOps[item.value];
            nstack.push(f($4c16e2382cfc2cd9$var$resolveExpression(n1, values)));
        } else if (type === (0, $57c046643b8fb398$export$89c431167cf161a1)) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift($4c16e2382cfc2cd9$var$resolveExpression(nstack.pop(), values));
            f = nstack.pop();
            if (f.apply && f.call) nstack.push(f.apply(undefined, args));
            else throw new Error(f + ' is not a function');
        } else if (type === (0, $57c046643b8fb398$export$5fbc192a0fb284ee)) // Create closure to keep references to arguments and expression
        nstack.push(function() {
            var n2 = nstack.pop();
            var args = [];
            var argCount = item.value;
            while(argCount-- > 0)args.unshift(nstack.pop());
            var n1 = nstack.pop();
            var f = function() {
                var scope = Object.assign({}, values);
                for(var i = 0, len = args.length; i < len; i++)scope[args[i]] = arguments[i];
                return $4c16e2382cfc2cd9$export$2e2bcd8739ae039(n2, expr, scope);
            };
            // f.name = n1
            Object.defineProperty(f, 'name', {
                value: n1,
                writable: false
            });
            values[n1] = f;
            return f;
        }());
        else if (type === (0, $57c046643b8fb398$export$8c955dcbad9059de)) nstack.push($4c16e2382cfc2cd9$var$createExpressionEvaluator(item, expr, values));
        else if (type === (0, $57c046643b8fb398$export$18e665f85cdda0f0)) nstack.push(item);
        else if (type === (0, $57c046643b8fb398$export$b6338d0dcc87172d)) {
            n1 = nstack.pop();
            nstack.push(n1[item.value]);
        } else if (type === (0, $57c046643b8fb398$export$1d3fc08acb362c1c)) nstack.pop();
        else if (type === (0, $57c046643b8fb398$export$ab9692aa28ce44b7)) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            nstack.push(args);
        } else throw new Error('invalid Expression');
    }
    if (nstack.length > 1) throw new Error('invalid Expression (parity)');
    // Explicitly return zero to avoid test issues caused by -0
    return nstack[0] === 0 ? 0 : $4c16e2382cfc2cd9$var$resolveExpression(nstack[0], values);
}
function $4c16e2382cfc2cd9$var$createExpressionEvaluator(token, expr, values) {
    if ($4c16e2382cfc2cd9$var$isExpressionEvaluator(token)) return token;
    return {
        type: (0, $57c046643b8fb398$export$18e665f85cdda0f0),
        value: function(scope) {
            return $4c16e2382cfc2cd9$export$2e2bcd8739ae039(token.value, expr, scope);
        }
    };
}
function $4c16e2382cfc2cd9$var$isExpressionEvaluator(n) {
    return n && n.type === (0, $57c046643b8fb398$export$18e665f85cdda0f0);
}
function $4c16e2382cfc2cd9$var$resolveExpression(n, values) {
    return $4c16e2382cfc2cd9$var$isExpressionEvaluator(n) ? n.value(values) : n;
}



function $b3cb779b8ad9a7d4$export$2e2bcd8739ae039(tokens, toJS) {
    var nstack = [];
    var n1, n2, n3;
    var f, args, argCount;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === (0, $57c046643b8fb398$export$5b94d32c6cd7452d)) {
            if (typeof item.value === 'number' && item.value < 0) nstack.push('(' + item.value + ')');
            else if (Array.isArray(item.value)) nstack.push('[' + item.value.map($b3cb779b8ad9a7d4$var$escapeValue).join(', ') + ']');
            else nstack.push($b3cb779b8ad9a7d4$var$escapeValue(item.value));
        } else if (type === (0, $57c046643b8fb398$export$dc35c38d7a9a4dc9)) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = item.value;
            if (toJS) {
                if (f === '^') nstack.push('Math.pow(' + n1 + ', ' + n2 + ')');
                else if (f === 'and') nstack.push('(!!' + n1 + ' && !!' + n2 + ')');
                else if (f === 'or') nstack.push('(!!' + n1 + ' || !!' + n2 + ')');
                else if (f === '||') nstack.push('(function(a,b){ return Array.isArray(a) && Array.isArray(b) ? a.concat(b) : String(a) + String(b); }((' + n1 + '),(' + n2 + ')))');
                else if (f === '==') nstack.push('(' + n1 + ' === ' + n2 + ')');
                else if (f === '!=') nstack.push('(' + n1 + ' !== ' + n2 + ')');
                else if (f === '[') nstack.push(n1 + '[(' + n2 + ') | 0]');
                else nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
            } else if (f === '[') nstack.push(n1 + '[' + n2 + ']');
            else nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
        } else if (type === (0, $57c046643b8fb398$export$89691300e9f21d05)) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = item.value;
            if (f === '?') nstack.push('(' + n1 + ' ? ' + n2 + ' : ' + n3 + ')');
            else throw new Error('invalid Expression');
        } else if (type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5) || type === (0, $57c046643b8fb398$export$b48ccc1026b7e1a9)) nstack.push(item.value);
        else if (type === (0, $57c046643b8fb398$export$6cd938543ae18fbf)) {
            n1 = nstack.pop();
            f = item.value;
            if (f === '-' || f === '+') nstack.push('(' + f + n1 + ')');
            else if (toJS) {
                if (f === 'not') nstack.push("(!" + n1 + ')');
                else if (f === '!') nstack.push('fac(' + n1 + ')');
                else nstack.push(f + '(' + n1 + ')');
            } else if (f === '!') nstack.push('(' + n1 + '!)');
            else nstack.push('(' + f + ' ' + n1 + ')');
        } else if (type === (0, $57c046643b8fb398$export$89c431167cf161a1)) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            f = nstack.pop();
            nstack.push(f + '(' + args.join(', ') + ')');
        } else if (type === (0, $57c046643b8fb398$export$5fbc192a0fb284ee)) {
            n2 = nstack.pop();
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            n1 = nstack.pop();
            if (toJS) nstack.push('(' + n1 + ' = function(' + args.join(', ') + ') { return ' + n2 + ' })');
            else nstack.push('(' + n1 + '(' + args.join(', ') + ') = ' + n2 + ')');
        } else if (type === (0, $57c046643b8fb398$export$b6338d0dcc87172d)) {
            n1 = nstack.pop();
            nstack.push(n1 + '.' + item.value);
        } else if (type === (0, $57c046643b8fb398$export$ab9692aa28ce44b7)) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            nstack.push('[' + args.join(', ') + ']');
        } else if (type === (0, $57c046643b8fb398$export$8c955dcbad9059de)) nstack.push('(' + $b3cb779b8ad9a7d4$export$2e2bcd8739ae039(item.value, toJS) + ')');
        else if (type === (0, $57c046643b8fb398$export$1d3fc08acb362c1c)) ;
        else throw new Error('invalid Expression');
    }
    if (nstack.length > 1) {
        if (toJS) nstack = [
            nstack.join(',')
        ];
        else nstack = [
            nstack.join(';')
        ];
    }
    return String(nstack[0]);
}
function $b3cb779b8ad9a7d4$var$escapeValue(v) {
    if (typeof v === 'string') return JSON.stringify(v).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    return v;
}



function $43026f3caf38aff5$export$2e2bcd8739ae039(array, obj) {
    for(var i = 0; i < array.length; i++){
        if (array[i] === obj) return true;
    }
    return false;
}


function $2bfb8be998453de6$export$2e2bcd8739ae039(tokens, symbols, options) {
    options = options || {};
    var withMembers = !!options.withMembers;
    var prevVar = null;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        if (item.type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5) || item.type === (0, $57c046643b8fb398$export$b48ccc1026b7e1a9)) {
            if (!withMembers && !(0, $43026f3caf38aff5$export$2e2bcd8739ae039)(symbols, item.value)) symbols.push(item.value);
            else if (prevVar !== null) {
                if (!(0, $43026f3caf38aff5$export$2e2bcd8739ae039)(symbols, prevVar)) symbols.push(prevVar);
                prevVar = item.value;
            } else prevVar = item.value;
        } else if (item.type === (0, $57c046643b8fb398$export$b6338d0dcc87172d) && withMembers && prevVar !== null) prevVar += '.' + item.value;
        else if (item.type === (0, $57c046643b8fb398$export$8c955dcbad9059de)) $2bfb8be998453de6$export$2e2bcd8739ae039(item.value, symbols, options);
        else if (prevVar !== null) {
            if (!(0, $43026f3caf38aff5$export$2e2bcd8739ae039)(symbols, prevVar)) symbols.push(prevVar);
            prevVar = null;
        }
    }
    if (prevVar !== null && !(0, $43026f3caf38aff5$export$2e2bcd8739ae039)(symbols, prevVar)) symbols.push(prevVar);
}


function $cf1bb23f368eed95$export$bfe37c1342e5eb83(tokens, parser) {
    this.tokens = tokens;
    this.parser = parser;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.functions = parser.functions;
}
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.simplify = function(values) {
    values = values || {};
    return new $cf1bb23f368eed95$export$bfe37c1342e5eb83((0, $af6574e1899c2e98$export$2e2bcd8739ae039)(this.tokens, this.unaryOps, this.binaryOps, this.ternaryOps, values), this.parser);
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.substitute = function(variable, expr) {
    if (!(expr instanceof $cf1bb23f368eed95$export$bfe37c1342e5eb83)) expr = this.parser.parse(String(expr));
    return new $cf1bb23f368eed95$export$bfe37c1342e5eb83((0, $093b31fd7ff23812$export$2e2bcd8739ae039)(this.tokens, variable, expr), this.parser);
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.evaluate = function(values) {
    values = values || {};
    return (0, $4c16e2382cfc2cd9$export$2e2bcd8739ae039)(this.tokens, this, values);
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.toString = function() {
    return (0, $b3cb779b8ad9a7d4$export$2e2bcd8739ae039)(this.tokens, false);
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.symbols = function(options) {
    options = options || {};
    var vars = [];
    (0, $2bfb8be998453de6$export$2e2bcd8739ae039)(this.tokens, vars, options);
    return vars;
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.variables = function(options) {
    options = options || {};
    var vars = [];
    (0, $2bfb8be998453de6$export$2e2bcd8739ae039)(this.tokens, vars, options);
    var functions = this.functions;
    return vars.filter(function(name) {
        return !(name in functions);
    });
};
$cf1bb23f368eed95$export$bfe37c1342e5eb83.prototype.toJSFunction = function(param, variables) {
    var expr = this;
    var f = new Function(param, 'with(this.functions) with (this.ternaryOps) with (this.binaryOps) with (this.unaryOps) { return ' + (0, $b3cb779b8ad9a7d4$export$2e2bcd8739ae039)(this.simplify(variables).tokens, true) + '; }'); // eslint-disable-line no-new-func
    return function() {
        return f.apply(expr, arguments);
    };
};


var $299818eeac0902f7$export$131f3e29b6f8439b = 'TEOF';
var $299818eeac0902f7$export$793ed84f5e13fedc = 'TOP';
var $299818eeac0902f7$export$fb24cfaa02f0afb7 = 'TNUMBER';
var $299818eeac0902f7$export$34bd3861491a5ef7 = 'TSTRING';
var $299818eeac0902f7$export$dc8583a644ac1e92 = 'TPAREN';
var $299818eeac0902f7$export$a1b2367580630a10 = 'TBRACKET';
var $299818eeac0902f7$export$5921c054f41c1b53 = 'TCOMMA';
var $299818eeac0902f7$export$d9354b608107e9e = 'TNAME';
var $299818eeac0902f7$export$874622e1f1ece709 = 'TSEMICOLON';
function $299818eeac0902f7$export$50792b0e93539fde(type, value, index) {
    this.type = type;
    this.value = value;
    this.index = index;
}
$299818eeac0902f7$export$50792b0e93539fde.prototype.toString = function() {
    return this.type + ': ' + this.value;
};



var $943942fd9e8a916e$exports = {};
(function(globalScope) {
    'use strict';
    /*!
   *  decimal.js v10.5.0
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = '0123456789abcdef', // The natural logarithm of 10 (1025 digits).
    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058', // Pi (1025 digits).
    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789', // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', precisionLimitExceeded = decimalError + 'Precision limit exceeded', cryptoUnavailable = decimalError + 'crypto unavailable', tag = '[object Decimal]', mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? '0' : '00';
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = '2.3283064365386962890625e-10';
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        // See https://github.com/MikeMcl/decimal.js/pull/217
        x = new Ctor(1).minus(x).div(x.plus(1)).sqrt().atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, -1);
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 1);
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|bigint|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|bigint|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|bigint|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + '').e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + '').length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? '-' + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = '2.3283064365386962890625e-10';
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` (`n` is -1) and `min` (`n` is 1).
   */ function maxOrMin(Ctor, args, n) {
        var k, y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            // NaN?
            if (!y.s) {
                x = y;
                break;
            }
            k = x.cmp(y);
            if (k === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // TODO BigInt str: no need to check for decimal point, exponential form or leading zeros.
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf('_') > -1) {
            str = str.replace(/(\d)_(?=\d)/g, '$1');
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === 'Infinity' || str === 'NaN') {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf('.');
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace('.', '');
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf('.');
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace('.', '');
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? '0p+0' : '0';
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += '0';
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = '1.'; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + '.' + str.slice(1);
                    }
                    str = str + (e < 0 ? 'p' : 'p+') + e;
                } else if (e < 0) {
                    for(; ++e;)str = '0' + str;
                    str = '0.' + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += '0';
                    else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
                }
            }
            str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|bigint|Decimal} The y-coordinate.
   * x {number|string|bigint|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|bigint|Decimal}
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -EXP_LIMIT,
            0,
            'toExpPos',
            0,
            EXP_LIMIT,
            'maxE',
            0,
            EXP_LIMIT,
            'minE',
            -EXP_LIMIT,
            0,
            'modulo',
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ': ' + v);
            }
        }
        if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|bigint|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === 'number') {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                }
                // Infinity or NaN?
                if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            }
            if (t === 'string') {
                if ((i = v.charCodeAt(0)) === 45) {
                    v = v.slice(1);
                    x.s = -1;
                } else {
                    if (i === 43) v = v.slice(1); // plus sign
                    x.s = 1;
                }
                return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
            }
            if (t === 'bigint') {
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                return parseDecimal(x, v.toString());
            }
            throw Error(invalidArgument + v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    'precision',
                    'rounding',
                    'toExpNeg',
                    'toExpPos',
                    'maxE',
                    'minE',
                    'modulo',
                    'crypto'
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|bigint|Decimal} The argument of the logarithm.
   * y {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, -1);
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, 1);
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The base.
   * y {number|string|bigint|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|bigint|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $943942fd9e8a916e$exports) {
        if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
            P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
            P[Symbol.toStringTag] = 'Decimal';
        }
        $943942fd9e8a916e$exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})($943942fd9e8a916e$exports);


function $abcf8174f51a8b2a$export$b55edb69cfa7ac57(parser, expression) {
    this.pos = 0;
    this.current = null;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.consts = parser.consts;
    this.expression = expression;
    this.savedPosition = 0;
    this.savedCurrent = null;
    this.options = parser.options;
    this.parser = parser;
}
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.newToken = function(type, value, pos) {
    return new (0, $299818eeac0902f7$export$50792b0e93539fde)(type, value, pos != null ? pos : this.pos);
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.save = function() {
    this.savedPosition = this.pos;
    this.savedCurrent = this.current;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.restore = function() {
    this.pos = this.savedPosition;
    this.current = this.savedCurrent;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.next = function() {
    if (this.pos >= this.expression.length) return this.newToken((0, $299818eeac0902f7$export$131f3e29b6f8439b), 'EOF');
    if (this.isWhitespace() || this.isComment()) return this.next();
    else if (this.isRadixInteger() || this.isNumber() || this.isOperator() || this.isString() || this.isParen() || this.isBracket() || this.isComma() || this.isSemicolon() || this.isNamedOp() || this.isConst() || this.isName()) return this.current;
    else this.parseError('Unknown character "' + this.expression.charAt(this.pos) + '"');
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isString = function() {
    var r = false;
    var startPos = this.pos;
    var quote = this.expression.charAt(startPos);
    if (quote === '\'' || quote === '"') {
        var index = this.expression.indexOf(quote, startPos + 1);
        while(index >= 0 && this.pos < this.expression.length){
            this.pos = index + 1;
            if (this.expression.charAt(index - 1) !== '\\') {
                var rawString = this.expression.substring(startPos + 1, index);
                this.current = this.newToken((0, $299818eeac0902f7$export$34bd3861491a5ef7), this.unescape(rawString), startPos);
                r = true;
                break;
            }
            index = this.expression.indexOf(quote, index + 1);
        }
    }
    return r;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isParen = function() {
    var c = this.expression.charAt(this.pos);
    if (c === '(' || c === ')') {
        this.current = this.newToken((0, $299818eeac0902f7$export$dc8583a644ac1e92), c);
        this.pos++;
        return true;
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isBracket = function() {
    var c = this.expression.charAt(this.pos);
    if ((c === '[' || c === ']') && this.isOperatorEnabled('[')) {
        this.current = this.newToken((0, $299818eeac0902f7$export$a1b2367580630a10), c);
        this.pos++;
        return true;
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isComma = function() {
    var c = this.expression.charAt(this.pos);
    if (c === ';') {
        this.current = this.newToken((0, $299818eeac0902f7$export$5921c054f41c1b53), ';');
        this.pos++;
        return true;
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isSemicolon = function() {
    var c;
    return false; // no semicolon parsing as it's used in place of comma
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isConst = function() {
    var startPos = this.pos;
    var i = startPos;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos || c !== '_' && c !== '.' && c !== ',' && (c < '0' || c > '9')) break;
        }
    }
    if (i > startPos) {
        var str = this.expression.substring(startPos, i);
        if (str in this.consts) {
            this.current = this.newToken((0, $299818eeac0902f7$export$fb24cfaa02f0afb7), this.consts[str]);
            this.pos += str.length;
            return true;
        }
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isNamedOp = function() {
    var startPos = this.pos;
    var i = startPos;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos || c !== '_' && (c < '0' || c > '9')) break;
        }
    }
    if (i > startPos) {
        var str = this.expression.substring(startPos, i);
        if (this.isOperatorEnabled(str) && (str in this.binaryOps || str in this.unaryOps || str in this.ternaryOps)) {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), str);
            this.pos += str.length;
            return true;
        }
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isName = function() {
    var startPos = this.pos;
    var i = startPos;
    var hasLetter = false;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos && (c === '$' || c === '_')) {
                if (c === '_') hasLetter = true;
                continue;
            } else if (i === this.pos || !hasLetter || c !== '_' && (c < '0' || c > '9')) break;
        } else hasLetter = true;
    }
    if (hasLetter) {
        var str = this.expression.substring(startPos, i);
        this.current = this.newToken((0, $299818eeac0902f7$export$d9354b608107e9e), str);
        this.pos += str.length;
        return true;
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isWhitespace = function() {
    var r = false;
    var c = this.expression.charAt(this.pos);
    while(c === ' ' || c === '\t' || c === '\n' || c === '\r'){
        r = true;
        this.pos++;
        if (this.pos >= this.expression.length) break;
        c = this.expression.charAt(this.pos);
    }
    return r;
};
var $abcf8174f51a8b2a$var$codePointPattern = /^[0-9a-f]{4}$/i;
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.unescape = function(v) {
    var index = v.indexOf('\\');
    if (index < 0) return v;
    var buffer = v.substring(0, index);
    while(index >= 0){
        var c = v.charAt(++index);
        switch(c){
            case '\'':
                buffer += '\'';
                break;
            case '"':
                buffer += '"';
                break;
            case '\\':
                buffer += '\\';
                break;
            case '/':
                buffer += '/';
                break;
            case 'b':
                buffer += '\b';
                break;
            case 'f':
                buffer += '\f';
                break;
            case 'n':
                buffer += '\n';
                break;
            case 'r':
                buffer += '\r';
                break;
            case 't':
                buffer += '\t';
                break;
            case 'u':
                // interpret the following 4 characters as the hex of the unicode code point
                var codePoint = v.substring(index + 1, index + 5);
                if (!$abcf8174f51a8b2a$var$codePointPattern.test(codePoint)) this.parseError('Illegal escape sequence: \\u' + codePoint);
                buffer += String.fromCharCode(parseInt(codePoint, 16));
                index += 4;
                break;
            default:
                throw this.parseError('Illegal escape sequence: "\\' + c + '"');
        }
        ++index;
        var backslash = v.indexOf('\\', index);
        buffer += v.substring(index, backslash < 0 ? v.length : backslash);
        index = backslash;
    }
    return buffer;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isComment = function() {
    var c = this.expression.charAt(this.pos);
    if (c === '/' && this.expression.charAt(this.pos + 1) === '*') {
        this.pos = this.expression.indexOf('*/', this.pos) + 2;
        if (this.pos === 1) this.pos = this.expression.length;
        return true;
    }
    return false;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isRadixInteger = function() {
    var pos = this.pos;
    if (pos >= this.expression.length - 2 || this.expression.charAt(pos) !== '0') return false;
    ++pos;
    var radix;
    var validDigit;
    if (this.expression.charAt(pos) === 'x') {
        radix = 16;
        validDigit = /^[0-9a-f]$/i;
        ++pos;
    } else if (this.expression.charAt(pos) === 'b') {
        radix = 2;
        validDigit = /^[01]$/i;
        ++pos;
    } else return false;
    var valid = false;
    var startPos = pos;
    while(pos < this.expression.length){
        var c = this.expression.charAt(pos);
        if (validDigit.test(c)) {
            pos++;
            valid = true;
        } else break;
    }
    if (valid) {
        //this.current = this.newToken(TNUMBER, parseInt(this.expression.substring(startPos, pos), radix));
        this.current = this.newToken((0, $299818eeac0902f7$export$fb24cfaa02f0afb7), new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(this.expression.substring(startPos, pos).replace(/,/gm, '.'), radix));
        this.pos = pos;
    }
    return valid;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isNumber = function() {
    var valid = false;
    var pos = this.pos;
    var startPos = pos;
    var resetPos = pos;
    var foundDot = false;
    var foundDigits = false;
    var c;
    while(pos < this.expression.length){
        c = this.expression.charAt(pos);
        if (c >= '0' && c <= '9' || !foundDot && (c === '.' || c === ',')) {
            if (c === '.' || c === ',') foundDot = true;
            else foundDigits = true;
            pos++;
            valid = foundDigits;
        } else break;
    }
    if (valid) resetPos = pos;
    if (c === 'e' || c === 'E') {
        pos++;
        var acceptSign = true;
        var validExponent = false;
        while(pos < this.expression.length){
            c = this.expression.charAt(pos);
            if (acceptSign && (c === '+' || c === '-')) acceptSign = false;
            else if (c >= '0' && c <= '9') {
                validExponent = true;
                acceptSign = false;
            } else break;
            pos++;
        }
        if (!validExponent) pos = resetPos;
    }
    if (valid) {
        //this.current = this.newToken(TNUMBER, parseFloat(this.expression.substring(startPos, pos)));
        this.current = this.newToken((0, $299818eeac0902f7$export$fb24cfaa02f0afb7), new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(this.expression.substring(startPos, pos).replace(/,/gm, '.')));
        this.pos = pos;
    } else this.pos = resetPos;
    return valid;
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isOperator = function() {
    var startPos = this.pos;
    var c = this.expression.charAt(this.pos);
    if (c === '+' || c === '-' || c === '*' || c === '/' || c === '%' || c === '^' || c === '?' || c === ':' || c === '.' || c === ',') this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), c);
    else if (c === "\u2219" || c === "\u2022") this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '*');
    else if (c === '>') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '>=');
            this.pos++;
        } else this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '>');
    } else if (c === '<') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '<=');
            this.pos++;
        } else this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '<');
    } else if (c === '|') {
        if (this.expression.charAt(this.pos + 1) === '|') {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '||');
            this.pos++;
        } else return false;
    } else if (c === '=') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '==');
            this.pos++;
        } else this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), c);
    } else if (c === '!') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), '!=');
            this.pos++;
        } else this.current = this.newToken((0, $299818eeac0902f7$export$793ed84f5e13fedc), c);
    } else return false;
    this.pos++;
    if (this.isOperatorEnabled(this.current.value)) return true;
    else {
        this.pos = startPos;
        return false;
    }
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.isOperatorEnabled = function(op) {
    return this.parser.isOperatorEnabled(op);
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.getCoordinates = function() {
    var line = 0;
    var column;
    var newline = -1;
    do {
        line++;
        column = this.pos - newline;
        newline = this.expression.indexOf('\n', newline + 1);
    }while (newline >= 0 && newline < this.pos);
    return {
        line: line,
        column: column
    };
};
$abcf8174f51a8b2a$export$b55edb69cfa7ac57.prototype.parseError = function(msg) {
    var coords = this.getCoordinates();
    throw new Error('parse error [' + coords.line + ':' + coords.column + ']: ' + msg);
};





function $2b618efbcd0928b5$export$5adb5a4467c85d1a(parser, tokenStream, options) {
    this.parser = parser;
    this.tokens = tokenStream;
    this.current = null;
    this.nextToken = null;
    this.next();
    this.savedCurrent = null;
    this.savedNextToken = null;
    this.allowMemberAccess = options.allowMemberAccess !== false;
}
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.next = function() {
    this.current = this.nextToken;
    return this.nextToken = this.tokens.next();
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.tokenMatches = function(token, value) {
    if (typeof value === 'undefined') return true;
    else if (Array.isArray(value)) return (0, $43026f3caf38aff5$export$2e2bcd8739ae039)(value, token.value);
    else if (typeof value === 'function') return value(token);
    else return token.value === value;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.save = function() {
    this.savedCurrent = this.current;
    this.savedNextToken = this.nextToken;
    this.tokens.save();
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.restore = function() {
    this.tokens.restore();
    this.current = this.savedCurrent;
    this.nextToken = this.savedNextToken;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.accept = function(type, value) {
    if (this.nextToken.type === type && this.tokenMatches(this.nextToken, value)) {
        this.next();
        return true;
    }
    return false;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.expect = function(type, value) {
    if (!this.accept(type, value)) {
        var coords = this.tokens.getCoordinates();
        throw new Error('parse error [' + coords.line + ':' + coords.column + ']: Expected ' + (value || type));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseAtom = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    if (this.accept((0, $299818eeac0902f7$export$d9354b608107e9e)) || this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), isPrefixOperator)) instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$c3edb8ae35b9c3a5), this.current.value));
    else if (this.accept((0, $299818eeac0902f7$export$fb24cfaa02f0afb7))) instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), this.current.value));
    else if (this.accept((0, $299818eeac0902f7$export$34bd3861491a5ef7))) instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5b94d32c6cd7452d), this.current.value));
    else if (this.accept((0, $299818eeac0902f7$export$dc8583a644ac1e92), '(')) {
        this.parseExpression(instr);
        this.expect((0, $299818eeac0902f7$export$dc8583a644ac1e92), ')');
    } else if (this.accept((0, $299818eeac0902f7$export$a1b2367580630a10), '[')) {
        if (this.accept((0, $299818eeac0902f7$export$a1b2367580630a10), ']')) instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$ab9692aa28ce44b7), 0));
        else {
            var argCount = this.parseArrayList(instr);
            instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$ab9692aa28ce44b7), argCount));
        }
    } else throw new Error('unexpected ' + this.nextToken);
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseExpression = function(instr) {
    var exprInstr = [];
    if (this.parseUntilEndStatement(instr, exprInstr)) return;
    this.parseVariableAssignmentExpression(exprInstr);
    if (this.parseUntilEndStatement(instr, exprInstr)) return;
    this.pushExpression(instr, exprInstr);
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.pushExpression = function(instr, exprInstr) {
    for(var i = 0, len = exprInstr.length; i < len; i++)instr.push(exprInstr[i]);
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseUntilEndStatement = function(instr, exprInstr) {
    if (!this.accept((0, $299818eeac0902f7$export$874622e1f1ece709))) return false;
    if (this.nextToken && this.nextToken.type !== (0, $299818eeac0902f7$export$131f3e29b6f8439b) && !(this.nextToken.type === (0, $299818eeac0902f7$export$dc8583a644ac1e92) && this.nextToken.value === ')')) exprInstr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$1d3fc08acb362c1c)));
    if (this.nextToken.type !== (0, $299818eeac0902f7$export$131f3e29b6f8439b)) this.parseExpression(exprInstr);
    instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), exprInstr));
    return true;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseArrayList = function(instr) {
    var argCount = 0;
    while(!this.accept((0, $299818eeac0902f7$export$a1b2367580630a10), ']')){
        this.parseExpression(instr);
        ++argCount;
        while(this.accept((0, $299818eeac0902f7$export$5921c054f41c1b53))){
            this.parseExpression(instr);
            ++argCount;
        }
    }
    return argCount;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseVariableAssignmentExpression = function(instr) {
    this.parseConditionalExpression(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), '=')){
        var varName = instr.pop();
        var varValue = [];
        var lastInstrIndex = instr.length - 1;
        if (varName.type === (0, $57c046643b8fb398$export$89c431167cf161a1)) {
            if (!this.tokens.isOperatorEnabled('()=')) throw new Error('function definition is not permitted');
            for(var i = 0, len = varName.value + 1; i < len; i++){
                var index = lastInstrIndex - i;
                if (instr[index].type === (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5)) instr[index] = new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$b48ccc1026b7e1a9), instr[index].value);
            }
            this.parseVariableAssignmentExpression(varValue);
            instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), varValue));
            instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$5fbc192a0fb284ee), varName.value));
            continue;
        }
        if (varName.type !== (0, $57c046643b8fb398$export$c3edb8ae35b9c3a5) && varName.type !== (0, $57c046643b8fb398$export$b6338d0dcc87172d)) throw new Error('expected variable for assignment');
        this.parseVariableAssignmentExpression(varValue);
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$b48ccc1026b7e1a9), varName.value));
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), varValue));
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)('='));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseConditionalExpression = function(instr) {
    this.parseOrExpression(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), '?')){
        var trueBranch = [];
        var falseBranch = [];
        this.parseConditionalExpression(trueBranch);
        this.expect((0, $299818eeac0902f7$export$793ed84f5e13fedc), ':');
        this.parseConditionalExpression(falseBranch);
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), trueBranch));
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), falseBranch));
        instr.push((0, $57c046643b8fb398$export$a7185502bcf21610)('?'));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseOrExpression = function(instr) {
    this.parseAndExpression(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), 'or')){
        var falseBranch = [];
        this.parseAndExpression(falseBranch);
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), falseBranch));
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)('or'));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseAndExpression = function(instr) {
    this.parseComparison(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), 'and')){
        var trueBranch = [];
        this.parseComparison(trueBranch);
        instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$8c955dcbad9059de), trueBranch));
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)('and'));
    }
};
var $2b618efbcd0928b5$var$COMPARISON_OPERATORS = [
    '==',
    '!=',
    '<',
    '<=',
    '>=',
    '>',
    'in'
];
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseComparison = function(instr) {
    this.parseAddSub(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), $2b618efbcd0928b5$var$COMPARISON_OPERATORS)){
        var op = this.current;
        this.parseAddSub(instr);
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)(op.value));
    }
};
var $2b618efbcd0928b5$var$ADD_SUB_OPERATORS = [
    '+',
    '-',
    '||'
];
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseAddSub = function(instr) {
    this.parseTerm(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), $2b618efbcd0928b5$var$ADD_SUB_OPERATORS)){
        var op = this.current;
        this.parseTerm(instr);
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)(op.value));
    }
};
var $2b618efbcd0928b5$var$TERM_OPERATORS = [
    '*',
    '/',
    '%'
];
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseTerm = function(instr) {
    this.parseFactor(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), $2b618efbcd0928b5$var$TERM_OPERATORS)){
        var op = this.current;
        this.parseFactor(instr);
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)(op.value));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseFactor = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    this.save();
    if (this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), isPrefixOperator)) {
        if (this.current.value !== '-' && this.current.value !== '+') {
            if (this.nextToken.type === (0, $299818eeac0902f7$export$dc8583a644ac1e92) && this.nextToken.value === '(') {
                this.restore();
                this.parseExponential(instr);
                return;
            } else if (this.nextToken.type === (0, $299818eeac0902f7$export$874622e1f1ece709) || this.nextToken.type === (0, $299818eeac0902f7$export$5921c054f41c1b53) || this.nextToken.type === (0, $299818eeac0902f7$export$131f3e29b6f8439b) || this.nextToken.type === (0, $299818eeac0902f7$export$dc8583a644ac1e92) && this.nextToken.value === ')') {
                this.restore();
                this.parseAtom(instr);
                return;
            }
        }
        var op = this.current;
        this.parseFactor(instr);
        instr.push((0, $57c046643b8fb398$export$d2f4ceacf005edb)(op.value));
    } else this.parseExponential(instr);
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseExponential = function(instr) {
    this.parsePostfixExpression(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), '^')){
        this.parseFactor(instr);
        instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)('^'));
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parsePostfixExpression = function(instr) {
    this.parseFunctionCall(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), '!'))instr.push((0, $57c046643b8fb398$export$d2f4ceacf005edb)('!'));
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseFunctionCall = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    if (this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), isPrefixOperator)) {
        var op = this.current;
        this.parseAtom(instr);
        instr.push((0, $57c046643b8fb398$export$d2f4ceacf005edb)(op.value));
    } else {
        this.parseMemberExpression(instr);
        while(this.accept((0, $299818eeac0902f7$export$dc8583a644ac1e92), '('))if (this.accept((0, $299818eeac0902f7$export$dc8583a644ac1e92), ')')) instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$89c431167cf161a1), 0));
        else {
            var argCount = this.parseArgumentList(instr);
            instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$89c431167cf161a1), argCount));
        }
    }
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseArgumentList = function(instr) {
    var argCount = 0;
    while(!this.accept((0, $299818eeac0902f7$export$dc8583a644ac1e92), ')')){
        this.parseExpression(instr);
        ++argCount;
        while(this.accept((0, $299818eeac0902f7$export$5921c054f41c1b53))){
            this.parseExpression(instr);
            ++argCount;
        }
    }
    return argCount;
};
$2b618efbcd0928b5$export$5adb5a4467c85d1a.prototype.parseMemberExpression = function(instr) {
    this.parseAtom(instr);
    while(this.accept((0, $299818eeac0902f7$export$793ed84f5e13fedc), '.') || this.accept((0, $299818eeac0902f7$export$a1b2367580630a10), '[')){
        var op = this.current;
        if (op.value === '.') {
            if (!this.allowMemberAccess) throw new Error('unexpected ".", member access is not permitted');
            this.expect((0, $299818eeac0902f7$export$d9354b608107e9e));
            instr.push(new (0, $57c046643b8fb398$export$f361d4ae234b90f4)((0, $57c046643b8fb398$export$b6338d0dcc87172d), this.current.value));
        } else if (op.value === '[') {
            if (!this.tokens.isOperatorEnabled('[')) throw new Error('unexpected "[]", arrays are disabled');
            this.parseExpression(instr);
            this.expect((0, $299818eeac0902f7$export$a1b2367580630a10), ']');
            instr.push((0, $57c046643b8fb398$export$f2bdb78bb4179fd7)('['));
        } else throw new Error('unexpected symbol: ' + op.value);
    }
};






function $2a225b244b037c62$export$e16d8520af44a096(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).add(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$f93b5905241a7cca(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$6e3a27864ab166fe(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).mul(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$159d9494db57879b(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$842a2cf37af977e1(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).mod(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$9c297f60e22e3389(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).pow(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$ee1b3e54f0441b22(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.concat(b);
    return '' + a + b;
}
function $2a225b244b037c62$export$411ce8e5a71e3069(a, b) {
    return a === b;
}
function $2a225b244b037c62$export$53a6892c50694894(a, b) {
    return a !== b;
}
function $2a225b244b037c62$export$f517ea36c68d4644(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).greaterThan(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$9b050841a3a1b328(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).lessThan(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$b5f536bfcbb0f057(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).greaterThanOrEqualTo(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$b0b8c4c49050ecd0(a, b) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).lessThanOrEqualTo(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(b));
}
function $2a225b244b037c62$export$cbd789348359c94d(a, b) {
    return Boolean(a && b);
}
function $2a225b244b037c62$export$f3b5097332f98b10(a, b) {
    return Boolean(a || b);
}
function $2a225b244b037c62$export$30e916785bb92ba0(a, b) {
    return (0, $43026f3caf38aff5$export$2e2bcd8739ae039)(b, a);
}
function $2a225b244b037c62$export$545004b505d7c555(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).sinh();
}
function $2a225b244b037c62$export$2e2fd1ad24e4d350(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).cosh();
}
function $2a225b244b037c62$export$7128670e45beef9a(a) {
    if (a === Infinity) return 1;
    if (a === -Infinity) return -1;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).tanh();
}
function $2a225b244b037c62$export$839d8a01b6af4fc0(a) {
    if (a === -Infinity || new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).toNumber() === -Infinity) return a;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asinh();
}
function $2a225b244b037c62$export$b26caf0f29211d08(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acosh();
}
function $2a225b244b037c62$export$21ea955025ceb08b(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atanh();
}
function $2a225b244b037c62$export$75e08744a3ff8516(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).log(10);
}
function $2a225b244b037c62$export$d9493ff0dfa0fdd5(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).mul(-1);
}
function $2a225b244b037c62$export$6003a5f097c73977(a) {
    return !a;
}
function $2a225b244b037c62$export$1fe87bd59b089f0(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).trunc();
}
function $2a225b244b037c62$export$4385e60b38654f68(a) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).random().mul(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a || 1).toNumber()));
}
function $2a225b244b037c62$export$329ce89a99f0e343(a) {
    return $2a225b244b037c62$export$a7ebe8cc6aaf8d37(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).add(1));
}
function $2a225b244b037c62$var$isInteger(value) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(value).isInteger();
}
var $2a225b244b037c62$var$GAMMA_G = 4.7421875;
var $2a225b244b037c62$var$GAMMA_P = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];
function $2a225b244b037c62$export$a7ebe8cc6aaf8d37(n) {
    const g = 7;
    const p = [
        '0.99999999999980993',
        '676.5203681218851',
        '-1259.1392167224028',
        '771.32342877765313',
        '-176.61502916214059',
        '12.507343278686905',
        '-0.13857109526572012',
        '9.9843695780195716e-6',
        '1.5056327351493116e-7'
    ];
    n = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n);
    if (n.isInteger()) {
        if (n.lte(0)) return n.isFinite() ? new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(Infinity) : new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(NaN);
        let res = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n.minus('1'));
        let value = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n.minus('2'));
        while(value.gt(1)){
            res = res.mul(value);
            value = value.minus(1);
        }
        if (res.eq(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(1);
        return res;
    }
    if (n.lt(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))('0.5'))) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $0d3ee02f91645496$export$6b5c1ceb16d01dc3)).div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $0d3ee02f91645496$export$6b5c1ceb16d01dc3)).mul(n)).sin()).div($2a225b244b037c62$export$a7ebe8cc6aaf8d37(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))('1').minus(n)));
    n = n.minus(1);
    let x = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(p[0]);
    for(let i = 1; i < g + 2; i++)x = x.plus(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(p[i]).div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n).plus(i)));
    let t = n.plus(g).plus('0.5');
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $0d3ee02f91645496$export$6b5c1ceb16d01dc3)).mul(2).sqrt().mul((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).pow(t, n.plus('0.5'))).mul((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).exp(t.mul(-1))).mul(x);
}
function $2a225b244b037c62$export$a0275d461c5d99ba(s) {
    if (Array.isArray(s)) return s.length;
    return String(s).length;
}
function $2a225b244b037c62$export$f95c7888b62f8e9a(...args) {
    let sum = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    let larg = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    for (const arg of args){
        const absArg = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(arg).abs();
        let div;
        if (larg.lt(absArg)) {
            div = larg.div(absArg);
            sum = sum.times(div.times(div)).plus(1);
            larg = absArg;
        } else if (!absArg.isZero()) {
            div = absArg.div(larg);
            sum = sum.plus(div.times(div));
        } else sum = sum.plus(absArg);
    }
    return larg.eq(Infinity) ? Infinity : larg.times(sum.sqrt());
}
function $2a225b244b037c62$export$355ef19165780f94(cond, yep, nope) {
    return cond ? yep : nope;
}
function $2a225b244b037c62$export$7978a6ddf29f4374(value, exp) {
    if (typeof exp === 'undefined' || new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(exp).isZero()) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(value).toDecimalPlaces(0);
    value = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(value);
    exp = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(exp).neg();
    if (!exp.isInteger()) return NaN;
    // Shift, round, and shift back
    const shift = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(10).pow(exp);
    return value.div(shift).toDecimalPlaces(0).times(shift);
}
function $2a225b244b037c62$export$c334169d3fe557ca(name, value, variables) {
    if (variables) variables[name] = value;
    return value;
}
function $2a225b244b037c62$export$2d8b5b380ceebe8b(array, index) {
    return array[index | 0];
}
function $2a225b244b037c62$export$8960430cfd85939f(array) {
    if (arguments.length === 1 && Array.isArray(array)) return (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).max.apply((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))), array);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).max.apply((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))), arguments);
}
function $2a225b244b037c62$export$96ec731ed4dcb222(array) {
    if (arguments.length === 1 && Array.isArray(array)) return (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).min.apply((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))), array);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).min.apply((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))), arguments);
}
function $2a225b244b037c62$export$dc30017ac4432edc(f, a) {
    if (typeof f !== 'function') throw new Error('First argument to map is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to map is not an array');
    return a.map(function(x, i) {
        return f(x, i);
    });
}
function $2a225b244b037c62$export$9b2fe6bd096a49b5(f, init, a) {
    if (typeof f !== 'function') throw new Error('First argument to fold is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to fold is not an array');
    return a.reduce(function(acc, x, i) {
        return f(acc, x, i);
    }, init);
}
function $2a225b244b037c62$export$84effe734e770183(f, a) {
    if (typeof f !== 'function') throw new Error('First argument to filter is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to filter is not an array');
    return a.filter(function(x, i) {
        return f(x, i);
    });
}
function $2a225b244b037c62$export$665b70f2f834b3f8(target, s) {
    if (!(Array.isArray(s) || typeof s === 'string')) throw new Error('Second argument to indexOf is not a string or array');
    return s.indexOf(target);
}
function $2a225b244b037c62$export$1153d461a945b3f7(sep, a) {
    if (!Array.isArray(a)) throw new Error('Second argument to join is not an array');
    return a.join(sep);
}
function $2a225b244b037c62$export$c5552dfdbc7cec71(x) {
    return (x > 0) - (x < 0) || +x;
}
var $2a225b244b037c62$var$ONE_THIRD = 1 / 3;
function $2a225b244b037c62$export$841fc4d5a1480b85(x) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x).cubeRoot();
}
function $2a225b244b037c62$export$b6c0a80d46d3391d(x) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x).exp().sub(1);
}
function $2a225b244b037c62$export$144dcf16adfb9698(x) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x).log(1 + x);
}
function $2a225b244b037c62$export$b9fae0bba9d9094d(x) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x).log().div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(Math.LN2));
}
function $2a225b244b037c62$export$8a63f25cc62965f1(array) {
    if (!Array.isArray(array)) throw new Error('Sum argument is not an array');
    return array.reduce(function(total, value) {
        return total + Number(value);
    }, 0);
}







function $b908519f244c0b58$export$86990d8264d956f2(n, r) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $2a225b244b037c62$export$329ce89a99f0e343)(n)).div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $2a225b244b037c62$export$329ce89a99f0e343)(r)).mul((0, $2a225b244b037c62$export$329ce89a99f0e343)(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n).minus(r))));
}
function $b908519f244c0b58$export$5bf81dffd4bc7b88(n, r) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))((0, $2a225b244b037c62$export$329ce89a99f0e343)(n)).div((0, $2a225b244b037c62$export$329ce89a99f0e343)(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n).minus(r)));
}
function $b908519f244c0b58$export$cc6710ee5f037d57(...numbers) {
    if (numbers.length == 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(NaN);
    const numberCount = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(numbers.length);
    let val = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    for (const num of numbers)val = val.plus(num);
    return val.div(numberCount);
}
/*
 add:
geomean
median
product
variance

stddev
absdev

binomcdf
binompmf
binommean
binomvar

hyperpmf
hypercdf
hypermean
hypervar

poipmf
poicdf
poimean
poivar
*/ function $b908519f244c0b58$var$mean(...args) {
    if (args.length === 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    const n = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(args.length);
    const numbers = args.map((num)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(num));
    const mean1 = numbers.reduce((sum, num)=>sum.plus(num), new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0)).div(n);
    return mean1;
}
function $b908519f244c0b58$var$variance(...args) {
    if (args.length === 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    const n = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(args.length);
    const numbers = args.map((num)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(num));
    const meanValue = $b908519f244c0b58$var$mean(...numbers);
    const varianceVal = numbers.reduce((sum, num)=>{
        const diff = num.minus(meanValue);
        return sum.plus(diff.pow(2));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0)).div(n);
    return varianceVal;
}
function $b908519f244c0b58$var$standardDeviation(...args) {
    return $b908519f244c0b58$var$variance(...args).sqrt();
}
function $b908519f244c0b58$var$median(...args) {
    if (args.length === 0) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    const numbers = args.map((num)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(num)).sort((a, b)=>a.lt(b) ? -1 : 1);
    const mid = Math.floor(numbers.length / 2);
    if (numbers.length % 2 === 0) return numbers[mid - 1].plus(numbers[mid]).div(2);
    else return numbers[mid];
}
// Binomial PMF
function $b908519f244c0b58$var$binompmf(x, N, p) {
    N = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(N);
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x);
    p = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(p);
    if (x.lt(0) || x.gt(N)) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    let coeff = $b908519f244c0b58$export$86990d8264d956f2(N, x);
    let px = p.pow(x);
    let qnx = (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).sub(1, p).pow(N.minus(x));
    return coeff.times(px).times(qnx);
}
// Binomial CDF (cumulative sum of PMF)
function $b908519f244c0b58$var$binomcdf(x, N, p) {
    let sum = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    for(let k = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0); k.lte(x); k = k.plus(1))sum = sum.plus($b908519f244c0b58$var$binompmf(k, N, p));
    return sum;
}
// Binomial Mean
function $b908519f244c0b58$var$binommean(N, p) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(N).times(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(p));
}
// Binomial Variance
function $b908519f244c0b58$var$binomvar(N, p) {
    let P = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(p);
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(N).times(P).times((0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).sub(1, P));
}
// hyperetric PMF
function $b908519f244c0b58$var$hyperpmf(x, N, K, n) {
    N = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(N);
    K = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(K);
    n = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n);
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(x);
    if (x.lt(0) || x.gt(K) || x.gt(n) || n.minus(x).gt(N.minus(K))) return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    let num = $b908519f244c0b58$export$86990d8264d956f2(K, x).times($b908519f244c0b58$export$86990d8264d956f2(N.minus(K), n.minus(x)));
    let denom = $b908519f244c0b58$export$86990d8264d956f2(N, n);
    return num.div(denom);
}
// hyperetric CDF (sum of PMFs)
function $b908519f244c0b58$var$hypercdf(x, N, K, n) {
    let sum = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0);
    for(let k = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0); k.lte(x); k = k.plus(1))sum = sum.plus($b908519f244c0b58$var$hyperpmf(k, N, K, n));
    return sum;
}
// hyperetric Mean
function $b908519f244c0b58$var$hypermean(N, K, n) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n).times(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(K).div(N));
}
// hyperetric Variance
function $b908519f244c0b58$var$hypervar(N, K, n) {
    let NK = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(K).div(N);
    let oneMinusNK = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(1).minus(NK);
    let factor = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(N).minus(n).div(N.minus(1));
    return new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(n).times(NK).times(oneMinusNK).times(factor);
}
const $b908519f244c0b58$export$27dc8a7226ca4279 = {
    nCr: $b908519f244c0b58$export$86990d8264d956f2,
    ncr: $b908519f244c0b58$export$86990d8264d956f2,
    nPr: $b908519f244c0b58$export$5bf81dffd4bc7b88,
    npr: $b908519f244c0b58$export$5bf81dffd4bc7b88,
    average: $b908519f244c0b58$export$cc6710ee5f037d57,
    avg: $b908519f244c0b58$export$cc6710ee5f037d57,
    standardDeviation: $b908519f244c0b58$var$standardDeviation,
    stddev: $b908519f244c0b58$var$standardDeviation,
    stdDev: $b908519f244c0b58$var$standardDeviation,
    mean: $b908519f244c0b58$var$mean,
    variance: $b908519f244c0b58$var$variance,
    median: $b908519f244c0b58$var$median,
    binomvar: $b908519f244c0b58$var$binomvar,
    binommean: $b908519f244c0b58$var$binommean,
    binomcdf: $b908519f244c0b58$var$binomcdf,
    binompmf: $b908519f244c0b58$var$binompmf,
    hypervar: $b908519f244c0b58$var$hypervar,
    hypermean: $b908519f244c0b58$var$hypermean,
    hypercdf: $b908519f244c0b58$var$hypercdf,
    hyperpmf: $b908519f244c0b58$var$hyperpmf
};


const $0d3ee02f91645496$export$6b5c1ceb16d01dc3 = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170';
const $0d3ee02f91645496$export$a9c23c6ac3fc3eca = '2.7182818284590452353602874713526624977572470936999595749669676277240766303535475945713821785251664';
function $0d3ee02f91645496$export$7acfa6ed01010e37(options, prefsRaw) {
    this.options = options || {};
    const prefs = prefsRaw ?? {
        isDegrees: false,
        shouldCleanTrigonometry: true,
        precision: 50,
        expLimit: 15,
        outputMode: 'decimal'
    };
    const { isDegrees: isDegrees } = prefs;
    (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).set({
        precision: prefs.precision,
        minE: -100,
        maxE: 9e15,
        toExpNeg: -prefs.expLimit,
        toExpPos: prefs.expLimit
    });
    const toRadians = (degrees)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(degrees).mul(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))($0d3ee02f91645496$export$6b5c1ceb16d01dc3).div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))('180')));
    const toDegrees = (radians)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(radians).mul(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))('180').div(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))($0d3ee02f91645496$export$6b5c1ceb16d01dc3)));
    const ZERO_THRESHOLD = new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))('0.0000000000000000000000000000000000000001');
    const clean = (value)=>prefs.shouldCleanTrigonometry ? value.abs().lt(ZERO_THRESHOLD) ? new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(0) : value : value;
    this.unaryOps = {
        sin: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).sin()),
        cos: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).cos()),
        tan: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).tan()),
        asin: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asin())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asin()),
        acos: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acos())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acos()),
        atan: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atan())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atan()),
        arcsin: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asin())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asin()),
        arccos: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acos())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acos()),
        arctan: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atan())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atan()),
        sinh: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).sinh()),
        cosh: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).cosh()),
        tanh: (a)=>clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(isDegrees ? toRadians(a) : a).tanh()),
        asinh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asinh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asinh()),
        acosh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acosh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acosh()),
        atanh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atanh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atanh()),
        arcsinh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asinh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).asinh()),
        arccosh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acosh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).acosh()),
        arctanh: (a)=>isDegrees ? toDegrees(clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atanh())) : clean(new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).atanh()),
        sqrt: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).sqrt(),
        cbrt: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).cbrt(),
        log: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).log(),
        log2: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).logarithm(2),
        ln: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).ln(),
        lg: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).log(10),
        log10: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).log(10),
        expm1: (0, $2a225b244b037c62$export$b6c0a80d46d3391d),
        log1p: (0, $2a225b244b037c62$export$144dcf16adfb9698),
        abs: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).abs(),
        ceil: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).ceil(),
        floor: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).floor(),
        round: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).round(),
        trunc: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).trunc(),
        '-': (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).mul(-1),
        '+': (str)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(`${str}`.replace(/,/gm, '.')),
        exp: (a)=>new (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports)))(a).exp,
        not: (0, $2a225b244b037c62$export$6003a5f097c73977),
        length: (0, $2a225b244b037c62$export$a0275d461c5d99ba),
        '!': (0, $2a225b244b037c62$export$329ce89a99f0e343),
        sign: (0, $2a225b244b037c62$export$c5552dfdbc7cec71)
    };
    this.binaryOps = {
        '+': (0, $2a225b244b037c62$export$e16d8520af44a096),
        '-': (0, $2a225b244b037c62$export$f93b5905241a7cca),
        '*': (0, $2a225b244b037c62$export$6e3a27864ab166fe),
        '/': (0, $2a225b244b037c62$export$159d9494db57879b),
        '%': (0, $2a225b244b037c62$export$842a2cf37af977e1),
        '^': (0, $2a225b244b037c62$export$9c297f60e22e3389),
        '||': (0, $2a225b244b037c62$export$ee1b3e54f0441b22),
        '==': (0, $2a225b244b037c62$export$411ce8e5a71e3069),
        '!=': (0, $2a225b244b037c62$export$53a6892c50694894),
        '>': (0, $2a225b244b037c62$export$f517ea36c68d4644),
        '<': (0, $2a225b244b037c62$export$9b050841a3a1b328),
        '>=': (0, $2a225b244b037c62$export$b5f536bfcbb0f057),
        '<=': (0, $2a225b244b037c62$export$b0b8c4c49050ecd0),
        and: (0, $2a225b244b037c62$export$cbd789348359c94d),
        or: (0, $2a225b244b037c62$export$f3b5097332f98b10),
        'in': (0, $2a225b244b037c62$export$30e916785bb92ba0),
        '=': (0, $2a225b244b037c62$export$c334169d3fe557ca),
        '[': (0, $2a225b244b037c62$export$2d8b5b380ceebe8b)
    };
    this.ternaryOps = {
        '?': (0, $2a225b244b037c62$export$355ef19165780f94)
    };
    this.functions = {
        random: (0, $2a225b244b037c62$export$4385e60b38654f68),
        fac: (0, $2a225b244b037c62$export$329ce89a99f0e343),
        min: (0, $2a225b244b037c62$export$96ec731ed4dcb222),
        max: (0, $2a225b244b037c62$export$8960430cfd85939f),
        hypot: (0, $2a225b244b037c62$export$f95c7888b62f8e9a),
        pyt: (0, $2a225b244b037c62$export$f95c7888b62f8e9a),
        pow: (0, $2a225b244b037c62$export$9c297f60e22e3389),
        atan2: (0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).atan2,
        'if': (0, $2a225b244b037c62$export$355ef19165780f94),
        gamma: (0, $2a225b244b037c62$export$a7ebe8cc6aaf8d37),
        roundTo: (0, $2a225b244b037c62$export$7978a6ddf29f4374),
        map: (0, $2a225b244b037c62$export$dc30017ac4432edc),
        fold: (0, $2a225b244b037c62$export$9b2fe6bd096a49b5),
        filter: (0, $2a225b244b037c62$export$84effe734e770183),
        indexOf: (0, $2a225b244b037c62$export$665b70f2f834b3f8),
        join: (0, $2a225b244b037c62$export$1153d461a945b3f7),
        sum: (0, $2a225b244b037c62$export$8a63f25cc62965f1),
        ...(0, $b908519f244c0b58$export$27dc8a7226ca4279)
    };
    this.consts = {
        E: $0d3ee02f91645496$export$a9c23c6ac3fc3eca,
        PI: $0d3ee02f91645496$export$6b5c1ceb16d01dc3,
        e: $0d3ee02f91645496$export$a9c23c6ac3fc3eca,
        pi: $0d3ee02f91645496$export$6b5c1ceb16d01dc3,
        Infinity: Infinity,
        infinity: Infinity,
        Infty: Infinity,
        infty: Infinity,
        Inf: Infinity,
        inf: Infinity,
        'true': true,
        'false': false
    };
}
$0d3ee02f91645496$export$7acfa6ed01010e37.prototype.parse = function(expr) {
    var instr = [];
    var parserState = new (0, $2b618efbcd0928b5$export$5adb5a4467c85d1a)(this, new (0, $abcf8174f51a8b2a$export$b55edb69cfa7ac57)(this, expr), {
        allowMemberAccess: this.options.allowMemberAccess
    });
    parserState.parseExpression(instr);
    parserState.expect((0, $299818eeac0902f7$export$131f3e29b6f8439b), 'EOF');
    return new (0, $cf1bb23f368eed95$export$bfe37c1342e5eb83)(instr, this);
};
$0d3ee02f91645496$export$7acfa6ed01010e37.prototype.evaluate = function(expr, variables) {
    return this.parse(expr).evaluate(variables);
};
var $0d3ee02f91645496$var$sharedParser = new $0d3ee02f91645496$export$7acfa6ed01010e37();
$0d3ee02f91645496$export$7acfa6ed01010e37.parse = function(expr) {
    return $0d3ee02f91645496$var$sharedParser.parse(expr);
};
$0d3ee02f91645496$export$7acfa6ed01010e37.evaluate = function(expr, variables) {
    return $0d3ee02f91645496$var$sharedParser.parse(expr).evaluate(variables);
};
var $0d3ee02f91645496$var$optionNameMap = {
    '+': 'add',
    '-': 'subtract',
    '*': 'multiply',
    '/': 'divide',
    '%': 'remainder',
    '^': 'power',
    '!': 'factorial',
    '<': 'comparison',
    '>': 'comparison',
    '<=': 'comparison',
    '>=': 'comparison',
    '==': 'comparison',
    '!=': 'comparison',
    '||': 'concatenate',
    'and': 'logical',
    'or': 'logical',
    'not': 'logical',
    '?': 'conditional',
    ':': 'conditional',
    '=': 'assignment',
    '[': 'array',
    '()=': 'fndef'
};
function $0d3ee02f91645496$var$getOptionName(op) {
    return $0d3ee02f91645496$var$optionNameMap.hasOwnProperty(op) ? $0d3ee02f91645496$var$optionNameMap[op] : op;
}
$0d3ee02f91645496$export$7acfa6ed01010e37.prototype.isOperatorEnabled = function(op) {
    var optionName = $0d3ee02f91645496$var$getOptionName(op);
    var operators = this.options.operators || {};
    return !(optionName in operators) || !!operators[optionName];
};



// default Decimal.js options
(0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports))).set({
    precision: 50,
    minE: -100,
    maxE: 100,
    toExpNeg: -10,
    toExpPos: 10
});
function $5dc6c2b0701b58c5$export$85778ab426688f15() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($943942fd9e8a916e$exports));
}
var // Backwards compatibility
$5dc6c2b0701b58c5$export$2e2bcd8739ae039 = {
    Parser: (0, $0d3ee02f91645496$export$7acfa6ed01010e37),
    Expression: (0, $cf1bb23f368eed95$export$bfe37c1342e5eb83),
    getDecimalInstance: $5dc6c2b0701b58c5$export$85778ab426688f15
};


function $889ebde4ebf95ac3$export$8a4528ea5590497a(props) {
    const LANG = 'fi';
    switch(LANG){
        case 'fi':
            return props.fi;
        case 'se':
            return props.se ?? props.en ?? props.fi;
        case 'en':
            return props.en ?? props.fi;
    }
    return props.fi;
}
function $889ebde4ebf95ac3$export$9a771d6906431624(props) {
    const LANG = 'fi';
    switch(LANG){
        case 'fi':
            return props.fi;
        case 'se':
            return props.se ?? props.en ?? props.fi;
        case 'en':
            return props.en ?? props.fi;
    }
    return props.fi;
}


var $f86c956d40cf56f6$export$e8858d3b310f790a = /*#__PURE__*/ function(CalcEvent) {
    CalcEvent["COMMAND_COPY_LAST"] = "COMMAND_COPY_LAST";
    CalcEvent["COMMAND_SELECT_EXPRESSION"] = "COMMAND_SELECT_EXPRESSION";
    CalcEvent["COMMAND_SET_EXPRESSION"] = "COMMAND_SET_EXPRESSION";
    CalcEvent["COMMAND_INSERT_EXPRESSION"] = "COMMAND_INSERT_EXPRESSION";
    CalcEvent["COMMAND_WRAP_EXPRESSION"] = "COMMAND_WRAP_EXPRESSION";
    CalcEvent["COMMAND_EVALUATE"] = "COMMAND_EVALUATE";
    CalcEvent["COMMAND_SIDEBAR_TAB"] = "COMMAND_SIDEBAR_TAB";
    CalcEvent["COMMAND_UPDATE_PREFS"] = "COMMAND_UPDATE_PREFS";
    CalcEvent["UPDATED_CALC_PREFS"] = "UPDATED_CALC_PREFS";
    CalcEvent["SCOPE_UPDATE"] = "SCOPE_UPDATE";
    return CalcEvent;
}({});





function $2102cb8c71cfa88f$export$39d8b84eed3ad504(state) {
    const [currentScope, setCurrentScope] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(state.scope);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onScopeUpdate() {
            setCurrentScope({
                ...state.scope
            });
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).SCOPE_UPDATE, onScopeUpdate);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).SCOPE_UPDATE, onScopeUpdate);
        };
    });
    return [
        currentScope,
        (setScope)=>{
            state.scope = {
                ...setScope(currentScope)
            };
            state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).SCOPE_UPDATE, state.prefs);
        }
    ];
}
function $2102cb8c71cfa88f$export$466b35482a091452(state) {
    const [currentPrefs, setCurrentPrefs] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        ...state.prefs
    });
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onPrefsChange(prefs) {
            setCurrentPrefs({
                ...prefs
            });
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).UPDATED_CALC_PREFS, onPrefsChange);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).UPDATED_CALC_PREFS, onPrefsChange);
        };
    }, []);
    return [
        currentPrefs,
        (setPrefs)=>{
            state.prefs = {
                ...setPrefs(currentPrefs)
            };
            state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).UPDATED_CALC_PREFS, state.prefs);
        }
    ];
}
function $2102cb8c71cfa88f$export$da0e093a0cc51f07(str) {
    const superscriptMap = {
        "\u2070": '0',
        "\xb9": '1',
        "\xb2": '2',
        "\xb3": '3',
        "\u2074": '4',
        "\u2075": '5',
        "\u2076": '6',
        "\u2077": '7',
        "\u2078": '8',
        "\u2079": '9'
    };
    return str.replace(/([0-9A-Za-z])([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, (match, base, exp)=>{
        const normalExp = exp.split('').map((char)=>superscriptMap[char] || char).join('');
        return base + '^' + normalExp;
    });
}
function $2102cb8c71cfa88f$export$ba92636697128f32(str) {
    return str.replace(/π/gm, '(pi)');
}



function $a6266bf11fb9bae5$export$2b87eb943c5d6596(props) {
    const { state: state } = props;
    const [currentPrefs, setPrefs] = (0, $2102cb8c71cfa88f$export$466b35482a091452)(state);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "angle-unit-switch",
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: (e)=>{
            e.preventDefault();
            setPrefs((prefs)=>({
                    ...prefs,
                    isDegrees: !prefs.isDegrees
                }));
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "radian",
        "data-active": `${!currentPrefs.isDegrees}`
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
        fi: "rad",
        se: "rad",
        en: "rad"
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "degree",
        "data-active": `${currentPrefs.isDegrees}`
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
        fi: "aste",
        se: "deg",
        en: "deg"
    })));
}







function $8135990bf53f8764$export$2e7a2f02633d86ce(props) {
    let icon = props.icon;
    if (!icon.startsWith('ri-')) icon = 'ri-' + icon;
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("i", {
        className: [
            icon
        ].join(' ')
    });
}



function $317aea4b386c2905$export$62f1204ada69e1c6(props) {
    const { state: state } = props;
    const [calcPrefs, setPrefs] = (0, $2102cb8c71cfa88f$export$466b35482a091452)(props.state);
    const [currentMenuOpen, setCurrentMenuOpen] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(-1);
    const menuSubmenus = [
        {
            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Istunto",
                en: "Session"
            }),
            menuItems: [
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Tyhjenn\xe4 muisti",
                        en: "Clear memory"
                    }),
                    onClick: ()=>{
                        const keys = Object.keys(state.scope);
                        for (const key of keys)delete state.scope[key];
                        state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).SCOPE_UPDATE, state.scope);
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Sulje",
                        en: "Quit"
                    }),
                    onClick: ()=>{
                        window.close();
                    }
                }
            ]
        },
        {
            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Muokkaa",
                en: "Edit"
            }),
            menuItems: [
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Kopioi",
                        en: "Copy"
                    }),
                    onClick: ()=>{
                        document.execCommand('copy');
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Kopioi viimeisin tulos",
                        en: "Copy last result"
                    }),
                    onClick: ()=>{
                        state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_COPY_LAST);
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Liit\xe4",
                        en: "Paste"
                    }),
                    onClick: ()=>{
                        navigator.clipboard.readText().then((textToPaste)=>{
                            document.execCommand('insertText', false, `${textToPaste}`);
                        }).catch((err)=>{
                            console.error(err);
                        });
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Valitse sy\xf6te",
                        en: "Select expression"
                    }),
                    onClick: ()=>{
                        state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SELECT_EXPRESSION);
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Tyhjenn\xe4 sy\xf6te",
                        en: "Clear expression"
                    }),
                    onClick: ()=>{
                        state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SET_EXPRESSION, '');
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Lis\xe4\xe4 sulut valinnan ymp\xe4rille",
                        en: "Wrap selection in parentheses"
                    }),
                    onClick: ()=>{
                        state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_WRAP_EXPRESSION, '(', ')');
                    }
                }
            ]
        },
        {
            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "N\xe4yt\xe4",
                en: "View"
            }),
            menuItems: [
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "N\xe4yt\xe4 sivupalkki",
                        en: "Show sidebar"
                    }),
                    isChecked: calcPrefs.isSidebarVisible,
                    onClick: ()=>{
                        setPrefs((prefs)=>({
                                ...prefs,
                                isSidebarVisible: !prefs.isSidebarVisible
                            }));
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "N\xe4yt\xe4 painikkeet",
                        en: "Show keypad"
                    }),
                    isChecked: calcPrefs.isKeypadVisible,
                    onClick: ()=>{
                        setPrefs((prefs)=>({
                                ...prefs,
                                isKeypadVisible: !prefs.isKeypadVisible
                            }));
                    }
                }
            ]
        },
        {
            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Asetukset",
                en: "Settings"
            }),
            menuItems: [
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Tuloksen tarkkuus",
                        en: "Result precision"
                    }),
                    submenu: [
                        ...[
                            5,
                            10,
                            20,
                            25,
                            50
                        ].map((n)=>({
                                title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                                    fi: `${n} desimaalia`,
                                    en: `${n} decimals`
                                }),
                                isRadio: true,
                                isChecked: calcPrefs.precision == n,
                                onClick: ()=>{
                                    setPrefs((prefs)=>({
                                            ...prefs,
                                            precision: n
                                        }));
                                }
                            }))
                    ]
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Kulmayksikk\xf6",
                        en: "Angle unit"
                    }),
                    submenu: [
                        {
                            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                                fi: "Radiaani",
                                en: "Radian"
                            }),
                            isRadio: true,
                            isChecked: !calcPrefs.isDegrees,
                            onClick: ()=>{
                                setPrefs((prefs)=>({
                                        ...prefs,
                                        isDegrees: false
                                    }));
                            }
                        },
                        {
                            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                                fi: "Aste",
                                en: "Degree"
                            }),
                            isRadio: true,
                            isChecked: calcPrefs.isDegrees,
                            onClick: ()=>{
                                setPrefs((prefs)=>({
                                        ...prefs,
                                        isDegrees: true
                                    }));
                            }
                        }
                    ]
                },
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "Eksponenttimuodon raja",
                        en: "Exponent notation limit"
                    }),
                    submenu: [
                        ...[
                            5,
                            10,
                            15,
                            20,
                            25,
                            50
                        ].map((n)=>({
                                title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                                    fi: `10e${n}`,
                                    en: `10e${n}`
                                }),
                                isRadio: true,
                                isChecked: calcPrefs.expLimit == n,
                                onClick: ()=>{
                                    setPrefs((prefs)=>({
                                            ...prefs,
                                            expLimit: n
                                        }));
                                }
                            }))
                    ]
                }
            ]
        },
        {
            title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Apua",
                en: "Help"
            }),
            menuItems: [
                {
                    title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                        fi: "K\xe4ytt\xf6ohje",
                        en: "Guide"
                    }),
                    onClick: ()=>{
                        setPrefs((prefs)=>({
                                ...prefs,
                                isSidebarVisible: true
                            }));
                        setTimeout(()=>{
                            state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SIDEBAR_TAB, 2);
                        }, 100);
                    }
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, menuSubmenus.map((submenu, i)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($317aea4b386c2905$export$967a445faec73a24, {
            key: i,
            title: submenu.title,
            menuItems: submenu.menuItems,
            isOpen: i == currentMenuOpen,
            onOpen: ()=>{
                if (i == currentMenuOpen) setCurrentMenuOpen(-1);
                else setCurrentMenuOpen(i);
            },
            onHover: ()=>{
                if (currentMenuOpen > -1) setCurrentMenuOpen(i);
            },
            onClose: ()=>{
                setCurrentMenuOpen(-1);
            }
        })));
}
function $317aea4b386c2905$export$967a445faec73a24(props) {
    const isVisible = props.isOpen;
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!isVisible) return;
        function onClickOutside(e) {
            if (!e.target || !(e.target instanceof HTMLElement) || !e.target.matches('.menu, .menu *, .abicrunch-menu-item, .abicrunch-menu-item *')) props.onClose();
        }
        document.body.addEventListener('click', onClickOutside);
        return ()=>{
            document.body.removeEventListener('click', onClickOutside);
        };
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "abicrunch-menu-item",
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: (e)=>{
            e.preventDefault();
            if (e.target && e.target instanceof HTMLElement && !e.target.matches('.abicrunch-menu-menu *')) props.onOpen();
        },
        onMouseEnter: (e)=>{
            props.onHover();
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", null, props.title), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "abicrunch-menu-menu",
        "data-visible": `${isVisible}`
    }, props.menuItems.map((item, i)=>item.submenu ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($317aea4b386c2905$export$74f4e84095d22f67, {
            title: item.title,
            onClose: ()=>{
                props.onClose();
            },
            menuItems: item.submenu
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            key: `${item.title} ${i}`,
            className: "item",
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: (e)=>{
                e.preventDefault();
                item.onClick && item.onClick();
                props.onClose();
            }
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, item.isRadio ? item.isChecked ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: "radio-button-line"
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: "checkbox-blank-circle-line"
        }) : item.isChecked ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: "check-line"
        }) : ''), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, item.title)))));
}
function $317aea4b386c2905$export$74f4e84095d22f67(props) {
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "item with-submenu",
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: (e)=>{
            e.preventDefault();
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, props.title), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "submenu"
    }, props.menuItems.map((item, i)=>item.submenu ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($317aea4b386c2905$export$74f4e84095d22f67, {
            title: item.title,
            menuItems: item.submenu,
            onClose: ()=>props.onClose()
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            key: `${item.title} ${i}`,
            className: "item",
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: (e)=>{
                e.preventDefault();
                item.onClick && item.onClick();
                props.onClose();
            }
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, item.isRadio ? item.isChecked ? /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: "radio-button-line"
        }) : /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: "checkbox-blank-circle-line"
        }) : ''), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, item.title)))));
}






const $99ee5e7074391fbc$export$a16e4b9ce9019fe8 = {
    'sin': {
        title: {
            fi: 'Sini',
            en: 'Sine'
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'cos': {
        title: {
            fi: 'Kosini',
            en: 'Cosine'
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'tan': {
        title: {
            fi: 'Tangentti',
            en: 'Tangent'
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'asin': {
        title: {
            fi: 'Arkussini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'acos': {
        title: {
            fi: 'Arkuskosini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'atan': {
        title: {
            fi: 'Arkustangentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arcsin': {
        title: {
            fi: 'Arkussini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arccos': {
        title: {
            fi: 'Arkuskosini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arctan': {
        title: {
            fi: 'Arkustangentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'sinh': {
        title: {
            fi: 'Hyperbolinen sini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'cosh': {
        title: {
            fi: 'Hyperbolinen kosini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'tanh': {
        title: {
            fi: 'Hyperbolinen tangentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'asinh': {
        title: {
            fi: 'Hyperbolinen arkussini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'acosh': {
        title: {
            fi: 'Hyperbolinen arkuskosini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'atanh': {
        title: {
            fi: 'Hyperbolinen arkustangentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arcsinh': {
        title: {
            fi: 'Hyperbolinen arkussini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arccosh': {
        title: {
            fi: 'Hyperbolinen arkuskosini',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'arctanh': {
        title: {
            fi: 'Hyperbolinen arkustangentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'sqrt': {
        title: {
            fi: "Neli\xf6juuri",
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'cbrt': {
        title: {
            fi: 'Kuutiojuuri',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'log': {
        title: {
            fi: 'Logaritmi',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'log2': {
        title: {
            fi: 'Logaritmi (2-kantainen)',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'ln': {
        title: {
            fi: 'Logaritmi (luonnollinen)',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'lg': {
        title: {
            fi: 'Logaritmi',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'log10': {
        title: {
            fi: 'Logaritmi (10-kantainen9',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'expm1': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'log1p': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'abs': {
        title: {
            fi: 'Itseisarvo',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'ceil': {
        title: {
            fi: 'Katto',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'floor': {
        title: {
            fi: 'Lattia',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'round': {
        title: {
            fi: "Py\xf6ristys",
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'trunc': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    '-': {
        title: {
            fi: 'Miinus',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '+': {
        title: {
            fi: 'Plus',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'exp': {
        title: {
            fi: 'Eksponentti',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'not': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'length': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    '!': {
        title: {
            fi: 'Kertoma',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'sign': {
        title: {
            fi: 'Merkki',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    '*': {
        title: {
            fi: 'Kertomerkki',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '/': {
        title: {
            fi: 'Jakolasku',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '%': {
        title: {
            fi: 'Modulo',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '^': {
        title: {
            fi: 'Potenssi',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '||': {
        title: {
            fi: 'Looginen TAI',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '==': {
        title: {
            fi: "Looginen YHT\xc4 SUURI",
            en: ''
        },
        args: [
            'a'
        ]
    },
    '!=': {
        title: {
            fi: 'Looginen ERISUURI',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '>': {
        title: {
            fi: 'Suurempi kuin',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '<': {
        title: {
            fi: 'Pienempi kuin',
            en: ''
        },
        args: [
            'a'
        ]
    },
    '>=': {
        title: {
            fi: "Suurempi tai yht\xe4 suuri kuin",
            en: ''
        },
        args: [
            'a'
        ]
    },
    '<=': {
        title: {
            fi: "Pienempi tai yht\xe4 suuri kuin",
            en: ''
        },
        args: [
            'a'
        ]
    },
    'and': {
        title: {
            fi: 'Looginen JA',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'or': {
        title: {
            fi: 'Looginen TAI',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'in': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'random': {
        title: {
            fi: 'Satunnaisluku',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'fac': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'min': {
        title: {
            fi: 'Minimi',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'max': {
        title: {
            fi: 'Maksimi',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'hypot': {
        title: {
            fi: 'Pythagoraan lause',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'pyt': {
        title: {
            fi: 'Pythagoraan lause',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'pow': {
        title: {
            fi: 'Potenssi',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'atan2': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'if': {
        title: {
            fi: 'Looginen JOS',
            en: ''
        },
        args: [
            'a'
        ]
    },
    'gamma': {
        title: {
            fi: 'Gamma',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'roundTo': {
        title: {
            fi: "Py\xf6rist\xe4 tarkkuuteen",
            en: ''
        },
        args: [
            'a',
            'n'
        ],
        brackets: true
    },
    'map': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'fold': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'filter': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'indexOf': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            'a'
        ],
        brackets: true
    },
    'join': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'sum': {
        title: {
            fi: '',
            en: ''
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'nCr': {
        title: {
            fi: 'nCr',
            en: 'nCr'
        },
        args: [
            'n',
            'r'
        ],
        brackets: true
    },
    'nPr': {
        title: {
            fi: 'nPr',
            en: 'nr'
        },
        args: [
            'n',
            'r'
        ],
        brackets: true
    },
    'average': {
        title: {
            fi: 'Keskiarvo',
            en: 'Average'
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'stddev': {
        title: {
            fi: 'Hajonta',
            en: 'Standard deviation'
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'mean': {
        title: {
            fi: 'Keskiarvo',
            en: 'Mean'
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'variance': {
        title: {
            fi: 'Varianssi',
            en: 'Variance'
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'median': {
        title: {
            fi: 'Mediaani',
            en: 'Median'
        },
        args: [
            '...'
        ],
        brackets: true
    },
    'binompmf': {
        title: {
            fi: 'binompmf',
            en: 'binompmf'
        },
        args: [
            'x',
            'N',
            'p'
        ],
        brackets: true
    },
    'binomcdf': {
        title: {
            fi: 'binomcdf',
            en: 'binomcdf'
        },
        args: [
            'x',
            'N',
            'p'
        ],
        brackets: true
    },
    'binommean': {
        title: {
            fi: 'binommean',
            en: 'binommean'
        },
        args: [
            'N',
            'p'
        ],
        brackets: true
    },
    'binomvar': {
        title: {
            fi: 'binomvar',
            en: 'binomvar'
        },
        args: [
            'N',
            'p'
        ],
        brackets: true
    },
    'hyperpmf': {
        title: {
            fi: 'hypergeompmf',
            en: 'hypergeompmf'
        },
        args: [
            'x',
            'N',
            'K',
            'n'
        ],
        brackets: true
    },
    'hypercdf': {
        title: {
            fi: 'hypergeomcdf',
            en: 'hypergeomcdf'
        },
        args: [
            'x',
            'N',
            'K',
            'n'
        ],
        brackets: true
    },
    'hypermean': {
        title: {
            fi: 'hypergeommean',
            en: 'hypergeommean'
        },
        args: [
            'N',
            'K',
            'n'
        ],
        brackets: true
    },
    'hypervar': {
        title: {
            fi: 'hypergeomvar',
            en: 'hypergeomvar'
        },
        args: [
            'N',
            'K',
            'n'
        ],
        brackets: true
    }
};
const $99ee5e7074391fbc$var$COMMAND_LIST = Object.entries($99ee5e7074391fbc$export$a16e4b9ce9019fe8);
$99ee5e7074391fbc$var$COMMAND_LIST.sort((a, b)=>a[0].localeCompare(b[0]));
function $99ee5e7074391fbc$export$e9ee7b5c3ad0baa4(props) {
    const { state: state } = props;
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-command-palette"
    }, $99ee5e7074391fbc$var$COMMAND_LIST.map(([commandName, commandInfo], n)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "calc-command",
            key: commandName,
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: (e)=>{
                e.preventDefault();
                state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_INSERT_EXPRESSION, commandName, commandInfo);
            },
            title: (0, $889ebde4ebf95ac3$export$9a771d6906431624)(commandInfo.title)
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "calc-command-key"
        }, commandName))));
}






function $51ea78abd91f251e$export$a1b7456850608ed(props) {
    const { state: state } = props;
    const [scope, updateScope] = (0, $2102cb8c71cfa88f$export$39d8b84eed3ad504)(state);
    const SCOPE_ENTRIES = Object.entries(scope);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-command-palette"
    }, SCOPE_ENTRIES.length == 0 && /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-palette-info"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
        fi: "M\xe4\xe4rittelem\xe4si funktiot ja muuttujat n\xe4kyv\xe4t t\xe4ss\xe4.",
        en: "User-defined functions and variables will be displayed here."
    })), SCOPE_ENTRIES.filter((en)=>!en[0].startsWith('____')).map(([key, value], n)=>{
        return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "calc-command",
            key: key,
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: (e)=>{
                e.preventDefault();
                state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_INSERT_EXPRESSION, key, {});
            }
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($51ea78abd91f251e$export$61881e03ca0d22b4, {
            state: state,
            name: key,
            value: value
        }));
    }));
}
function $51ea78abd91f251e$export$61881e03ca0d22b4(props) {
    const { state: state } = props;
    switch(typeof props.value){
        case 'function':
            return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                className: "calc-command-key"
            }, props.name, "()"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                className: "calc-command-value"
            }, " = ", state.scope[`____${props.name}`] ?? (0, $889ebde4ebf95ac3$export$9a771d6906431624)({
                fi: 'funktio',
                en: 'function'
            })));
        default:
            return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                className: "calc-command-key"
            }, props.name), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
                className: "calc-command-value"
            }, " = ", `${props.value}`));
    }
}





const $c19dc004161fbed3$var$KEYS = [
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "7"),
        input: '7'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "8"),
        input: '8'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "9"),
        input: '9'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "big"
        }, "\xf7"),
        input: '/'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "C"),
        command: 'clear'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "\u221A"),
        input: 'sqrt('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "\u03C0"),
        input: "\u03C0"
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "exp"),
        input: 'exp('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "ln"),
        input: 'ln('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "4"),
        input: '4'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "5"),
        input: '5'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "6"),
        input: '6'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "big"
        }, "\xd7"),
        input: '*'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "E"),
        input: 'e'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "^"),
        input: '^'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "ans"),
        input: 'ans'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "sin"),
        input: 'sin('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "sin", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("sup", null, "-1")),
        input: 'arcsin('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "1"),
        input: '1'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "2"),
        input: '2'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "3"),
        input: '3'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "big"
        }, "\u2013"),
        input: '-'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "("),
        input: '('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, ")"),
        input: ')'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "x"),
        input: 'x'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "cos"),
        input: 'cos('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "cos", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("sup", null, "-1")),
        input: 'arccos('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "0"),
        input: '0'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, ","),
        input: ','
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "="),
        command: '='
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("span", {
            className: "big"
        }, "+"),
        input: '+'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "%"),
        input: '%'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "!"),
        input: '!'
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "x="),
        input: 'x='
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "tan"),
        input: 'tan('
    },
    {
        title: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, "tan", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("sup", null, "-1")),
        input: 'arctan('
    }
];
function $c19dc004161fbed3$export$beeb967f788189ab(props) {
    const { state: state } = props;
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-keypad"
    }, $c19dc004161fbed3$var$KEYS.map((key, n)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "key",
            key: n,
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: (e)=>{
                e.preventDefault();
                if (key.input) state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_INSERT_EXPRESSION, key.input, {
                    brackets: false
                });
                else {
                    if (key.command == 'clear') state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SET_EXPRESSION, '');
                    else if (key.command == '=') state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_EVALUATE, '');
                }
            }
        }, key.title)));
}




const $e9029b67063244e2$var$GUIDE_PAGES = {
    'Luvut|Number format': {
        fi: [
            "Desimaalit voi erottaa pisteell\xe4 tai pilkulla (1.5 ja 1,5 kelpaavat).",
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "Heksa-, oktaali- ja bin\xe4\xe4rilukuja"), " ei tueta t\xe4ll\xe4 hetkell\xe4.")
        ],
        en: [
            'Comma and dot are the accepted decimal separators (1.5 and 1,5 are valid).',
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "Hex, binary, and octal"), " numbers are not supported at the moment.")
        ]
    },
    'Laskutoimitukset|Operations': {
        fi: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "+"), " yhteenlasku"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "-"), " v\xe4hennyslasku/miinus"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "*"), " kertomerkki"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "/"), " jakomerkki"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "sqrt("), " neli\xf6juuri"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "^"), " potenssi"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "!"), " kertoma"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Komentopaletista l\xf6ytyy lista komennoista ja funktioista."))
        ],
        en: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "+"), " addition"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "-"), " subtraction/minus"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "*"), " multiplication"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "/"), " division"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "sqrt("), " square root"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "^"), " exponentiation"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "!"), " factorial"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "The command palette contains a list of available commands and functions."))
        ]
    },
    'Komennot ja funktiot|Commands and functions': {
        fi: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Funktion k\xe4ytt\xe4minen: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "komento(parametrit)")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Parametrit erotellaan puolipisteell\xe4 ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, ";"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "variance(1; 2; 3)")))
        ],
        en: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Using a function: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "command(parameters)")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Parameters are separated by a semicolon ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, ";"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "variance(1; 2; 3)")))
        ]
    },
    "K\xe4ytt\xe4j\xe4n funktiot|User functions": {
        fi: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Funktion m\xe4\xe4rittely: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "f(x) = lauseke"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "esim. ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "g(x)=(x-1)^2")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Funktion k\xe4ytt\xe4minen: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "f(5)"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "g(f(2))")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Muuttujan m\xe4\xe4rittely: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "a = 5"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "xyz = 5^2 - 5!"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "pallot = 199"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null)), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Laskin tallettaa edellisen vastauksen arvon muuttujaan ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "ans")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Funktion tai muuttujan voi m\xe4\xe4ritell\xe4 uudelleen"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Tallennetut funktiot ja muuttujat voi tyhjent\xe4\xe4 Istunto-valikosta"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Sivupalkin toiselta v\xe4lilehdelt\xe4 l\xf6ytyy luettelo talletetuista funktioista ja muuttujista"))
        ],
        en: [
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("ul", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Defining a function: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "f(x) = expression"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), "e.g., ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "g(x)=(x-1)^2")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Using a function: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "f(5)"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "g(f(2))")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Defining a variable: ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "a = 5"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "xyz = 5^2 - 5!"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "balls = 199"), " ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null)), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "The calculator stores the last answer in the variable ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("code", null, "ans")), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Functions and variables can be redefined"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "Saved functions and variables can be cleared from the Session menu"), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("li", null, "A list of stored functions and variables can be found in the second tab of the sidebar"))
        ]
    },
    "Kulmayksikk\xf6|Angle unit": {
        fi: [
            "Vaihda kulmayksikk\xf6 asteiden ja radiaanien v\xe4lill\xe4 Asetukset-valikosta tai oikean yl\xe4kulman painikkeesta."
        ],
        en: [
            'Use the Settings menu to change the angle unit, or click on the button in the top right corner.'
        ]
    },
    'Tuloksen tarkkuus|Result precision': {
        fi: [
            'Tuloksen tarkkuutta ja kymmenpotenssin rajaa voi muuttaa Asetukset-valikosta.'
        ],
        en: [
            'The result precision and scientific notation threshold can be adjusted in the Settings menu.'
        ]
    },
    'Painikkeet|Buttons': {
        fi: [
            "N\xe4ytt\xf6n\xe4pp\xe4imet eli laskimen painikkeet saa n\xe4kyviin N\xe4yt\xe4-valikosta. Voit my\xf6s kirjoittaa sy\xf6tekentt\xe4\xe4n n\xe4pp\xe4imist\xf6n avulla."
        ],
        en: [
            'The on-screen calculator buttons can be enabled from the View menu. You can also enter expressions using the keyboard.'
        ]
    },
    'Tietoa ohjelmasta|About the program': {
        fi: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "AbiCrunch v0.0.1 ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null)), "\xa9 Roni Lehto 2025", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "AbiCrunch on selain\xadteknologiaan perustuva tieteellinen laskin."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "AbiCrunch on avointa l\xe4hde\xadkoodia ja perustuu useisiin avoimen l\xe4hde\xadkoodin ohjelma\xadkirjastoihin."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Abitti\xae on Ylioppilas\xadtutkinto\xadlauta\xadkunnan rekister\xf6ity tavaramerkki. T\xe4m\xe4 ohjelmisto ei (ainakaan toistaiseksi) ole YTL:n tuottama tai virallisesti hyv\xe4ksym\xe4, eik\xe4 osa Abitti\xae-j\xe4rjestelm\xe4\xe4."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Koodattu \u2665 Tampereella")),
        en: /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("b", null, "AbiCrunch v0.0.1 ", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("br", null)), "\xa9 Roni Lehto 2025", /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "AbiCrunch is a web-based scientific calculator."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "AbiCrunch is open-source and built upon multiple open-source libraries."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Abitti\xae is a registered trademark of the Matriculation Examination Board. This software is not (at least for now) produced or officially approved by MEB, nor is it part of the Abitti\xae system."), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, "Coded with \u2665 in Tampere"))
    }
};
function $e9029b67063244e2$export$6010deb57ec5f5d9(props) {
    const { state: state } = props;
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-guide",
        style: {
            padding: '4px'
        }
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("p", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
        fi: "Huomaathan, ett\xe4 t\xe4m\xe4 ohje on toistaiseksi keskener\xe4inen.",
        en: "Please note that this guide is still Work in Progress."
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, Object.entries($e9029b67063244e2$var$GUIDE_PAGES).map((en, n)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("details", {
            key: en[0]
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("summary", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
            fi: en[0].split('|')[0],
            en: en[0].split('|')[1]
        })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), en[1]))))));
}


const $be839ebd791210a3$var$DecimalInstance = (0, $5dc6c2b0701b58c5$export$85778ab426688f15)();
function $be839ebd791210a3$export$45f572fa777f8aba(props) {
    const { state: state } = props;
    const [historyLines, setHistoryLines] = (0, $204a33a7557cbbd0$export$60241385465d0a34)([]);
    const [historyBrowse, setHistoryBrowse] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    const [inputText, setInputText] = (0, $204a33a7557cbbd0$export$60241385465d0a34)('');
    const [selection, setSelection] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        start: 0,
        end: 0,
        direction: 'forward'
    });
    const refHistory = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const refInput = (0, $204a33a7557cbbd0$export$b8f5890fc79d6aca)(null);
    const [currentPrefs, setCurrentPrefs] = (0, $204a33a7557cbbd0$export$60241385465d0a34)({
        ...state.prefs
    });
    const parser = (0, $204a33a7557cbbd0$export$1538c33de8887b59)(()=>new (0, $0d3ee02f91645496$export$7acfa6ed01010e37)({}, currentPrefs), [
        currentPrefs
    ]);
    function evalLine(line) {
        try {
            line = (0, $2102cb8c71cfa88f$export$da0e093a0cc51f07)(line);
            line = (0, $2102cb8c71cfa88f$export$ba92636697128f32)(line);
            const expr = parser.parse(line);
            const res = expr.evaluate(state.scope);
            let resDisplay = `${res}`;
            switch(typeof res){
                case 'function':
                    resDisplay = `${line}`;
                    state.scope[`____${res.name}`] = line.split('=').slice(1).join('=').trim();
                    break;
            }
            state.scope[`ans`] = res;
            setHistoryLines((l)=>[
                    ...l,
                    {
                        input: line,
                        output: `${resDisplay}`
                    }
                ]);
            console.log(res, state.scope);
            state.events.emit((0, $f86c956d40cf56f6$export$e8858d3b310f790a).SCOPE_UPDATE);
        } catch (err) {
            setHistoryLines((l)=>[
                    ...l,
                    {
                        hasError: true,
                        input: line,
                        output: `${err}`
                    }
                ]);
            console.error(err);
        }
    }
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onPrefsChange(prefs) {
            setCurrentPrefs({
                ...prefs
            });
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).UPDATED_CALC_PREFS, onPrefsChange);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).UPDATED_CALC_PREFS, onPrefsChange);
        };
    }, []);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (!refHistory.current) return;
        refHistory.current.scrollTop = refHistory.current.scrollHeight;
    }, [
        historyLines
    ]);
    (0, $204a33a7557cbbd0$export$e5c5a5f917a5871c)(()=>{
        refInput.current?.setSelectionRange(selection.start, selection.end, selection.direction);
    }, [
        selection
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onCopyLast() {
            try {
                navigator.clipboard.writeText(historyLines.at(-1)?.output ?? '').catch((err)=>{
                    console.error(err);
                });
            } catch (err) {
                console.error(err);
            }
        }
        function onSetExpression(toValue) {
            setInputText(`${toValue ?? ''}`);
        }
        function onInsertExpression(addValue, commandInfo) {
            console.log(selection.start, selection.end);
            if (selection.start != selection.end) {
                if (commandInfo.brackets) {
                    setInputText((t)=>t.substring(0, selection.start) + addValue + '(' + t.substring(selection.start, selection.end) + ')' + t.substring(selection.end));
                    setSelection({
                        direction: 'forward',
                        start: selection.start + addValue.length + 1,
                        end: selection.end + addValue.length + 1
                    });
                } else {
                    setInputText((t)=>t.substring(0, selection.start) + addValue + '(' + t.substring(selection.start, selection.end) + ')' + t.substring(selection.end));
                    setSelection({
                        direction: 'forward',
                        start: selection.start + addValue.length + 1,
                        end: selection.end + addValue.length + 1
                    });
                }
            } else {
                const cursorPos = selection.start;
                if (commandInfo.brackets) {
                    setInputText((t)=>t.substring(0, cursorPos) + addValue + '()' + t.substring(cursorPos));
                    setSelection({
                        direction: 'forward',
                        start: cursorPos + addValue.length + 1,
                        end: cursorPos + addValue.length + 1
                    });
                } else {
                    setInputText((t)=>t.substring(0, cursorPos) + addValue + t.substring(cursorPos));
                    setSelection({
                        direction: 'forward',
                        start: cursorPos + addValue.length,
                        end: cursorPos + addValue.length
                    });
                }
            }
            setTimeout(()=>{
                if (document.activeElement != refInput.current) refInput.current?.focus();
            }, 1);
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_COPY_LAST, onCopyLast);
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SET_EXPRESSION, onSetExpression);
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_INSERT_EXPRESSION, onInsertExpression);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_COPY_LAST, onCopyLast);
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SET_EXPRESSION, onSetExpression);
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_INSERT_EXPRESSION, onInsertExpression);
        };
    }, [
        historyLines,
        selection
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onSelectExpression() {
            setTimeout(()=>{
                refInput.current?.select();
            }, 1);
        }
        function onWrapExpression(wrapLeft, wrapRight) {
            if (!refInput.current) return;
            const selStart = refInput.current.selectionStart || 0;
            const selEnd = refInput.current.selectionEnd || 0;
            setInputText((text)=>{
                if (selStart == selEnd) return text;
                return text.substring(0, selStart) + wrapLeft + text.substring(selStart, selEnd) + wrapRight + text.substring(selEnd);
            });
            setSelection({
                ...selection,
                start: selection.start,
                end: selection.end + 2
            });
        }
        function onEvalExpression() {
            evalLine(inputText);
            setInputText('');
            setHistoryBrowse(0);
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SELECT_EXPRESSION, onSelectExpression);
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_WRAP_EXPRESSION, onWrapExpression);
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_EVALUATE, onEvalExpression);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SELECT_EXPRESSION, onSelectExpression);
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_WRAP_EXPRESSION, onWrapExpression);
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_EVALUATE, onEvalExpression);
        };
    }, [
        selection,
        inputText
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (historyBrowse == 0) return;
        const toLine = historyLines.at(-historyBrowse)?.input ?? '';
        setInputText(toLine);
        setSelection({
            start: toLine.length,
            end: toLine.length,
            direction: 'forward'
        });
    }, [
        historyBrowse,
        historyLines
    ]);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        if (currentPrefs.isSidebarVisible) {
            document.body.classList.add('has-sidebar');
            document.body.classList.remove('no-sidebar');
        } else {
            document.body.classList.remove('has-sidebar');
            document.body.classList.add('no-sidebar');
        }
        if (currentPrefs.isKeypadVisible) {
            document.body.classList.add('has-keypad');
            document.body.classList.remove('no-keypad');
        } else {
            document.body.classList.remove('has-keypad');
            document.body.classList.add('no-keypad');
        }
    }, [
        currentPrefs
    ]);
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: [
            'abicrunch'
        ].join(' ')
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "top"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "menu"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $317aea4b386c2905$export$62f1204ada69e1c6), {
        state: props.state
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "switch"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $a6266bf11fb9bae5$export$2b87eb943c5d6596), {
        state: props.state
    }))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "calc-body"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "left"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "history",
        ref: refHistory
    }, historyLines.map((line, n)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "history-line",
            "data-has-error": `${line.hasError ?? false}`,
            key: n
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "in"
        }, line.input), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "out"
        }, "= ", line.output)))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "input"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("input", {
        autoComplete: 'off',
        spellcheck: false,
        ref: refInput,
        value: inputText,
        onInput: (e)=>{
            setInputText(e.currentTarget.value);
            setSelection({
                start: e.currentTarget.selectionStart || 0,
                end: e.currentTarget.selectionEnd || 0,
                direction: e.currentTarget.selectionDirection || 'forward'
            });
        },
        onKeyDown: (e)=>{
            if (e.key == 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                evalLine(inputText);
                setInputText('');
                setHistoryBrowse(0);
            } else if (e.key == 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                setHistoryBrowse((b)=>Math.min(historyLines.length, b + 1));
            } else if (e.key == 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                setHistoryBrowse((b)=>Math.max(0, b - 1));
            }
        },
        onSelect: (e)=>{
            setSelection({
                start: e.currentTarget.selectionStart || 0,
                end: e.currentTarget.selectionEnd || 0,
                direction: e.currentTarget.selectionDirection || 'forward'
            });
        }
    }))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "right"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)($be839ebd791210a3$export$d6ec5f6c5146fa88, {
        state: state
    })), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "bottom"
    }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $c19dc004161fbed3$export$beeb967f788189ab), {
        state: state
    }))));
}
function $be839ebd791210a3$export$d6ec5f6c5146fa88(props) {
    const { state: state } = props;
    const [currentTab, setCurrentTab] = (0, $204a33a7557cbbd0$export$60241385465d0a34)(0);
    (0, $204a33a7557cbbd0$export$6d9c69b0de29b591)(()=>{
        function onChangeTab(toTab) {
            setCurrentTab(toTab);
        }
        state.events.addListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SIDEBAR_TAB, onChangeTab);
        return ()=>{
            state.events.removeListener((0, $f86c956d40cf56f6$export$e8858d3b310f790a).COMMAND_SIDEBAR_TAB, onChangeTab);
        };
    }, []);
    const TABS = [
        [
            'commands',
            'puzzle-line',
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Komennot",
                en: "Commands"
            }),
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $99ee5e7074391fbc$export$e9ee7b5c3ad0baa4), {
                state: state
            }))
        ],
        [
            'variables',
            'formula',
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Muisti",
                en: "Memory"
            }),
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $51ea78abd91f251e$export$a1b7456850608ed), {
                state: state
            }))
        ],
        [
            'help',
            'lightbulb-line',
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $889ebde4ebf95ac3$export$8a4528ea5590497a), {
                fi: "Ohje",
                en: "Guide"
            }),
            /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $e9029b67063244e2$export$6010deb57ec5f5d9), {
                state: state
            }))
        ]
    ];
    return /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "tabs"
    }, TABS.map((item, i)=>/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
            className: "tab",
            "data-active": `${currentTab == i}`,
            key: i,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: (e)=>{
                e.preventDefault();
                setCurrentTab(i);
            }
        }, /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $8135990bf53f8764$export$2e7a2f02633d86ce), {
            icon: item[1]
        })))), /*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)("div", {
        className: "tabs-wrapper"
    }, TABS[currentTab][3]));
}


var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


const $38d6cc12cd11cfd3$var$base = document.querySelector('#base');
if (!$38d6cc12cd11cfd3$var$base) throw new Error(`No base?!`);
const $38d6cc12cd11cfd3$var$GLOBAL_STATE = {
    events: new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))(),
    prefs: {
        isSidebarVisible: true,
        isKeypadVisible: true,
        isDegrees: false,
        shouldCleanTrigonometry: true,
        precision: 50,
        expLimit: 15,
        outputMode: 'decimal'
    },
    scope: {}
};
const $38d6cc12cd11cfd3$var$baseUrl = new URL(window.location.href);
const $38d6cc12cd11cfd3$var$baseParams = $38d6cc12cd11cfd3$var$baseUrl.searchParams;
if ($38d6cc12cd11cfd3$var$baseParams.has('view') && $38d6cc12cd11cfd3$var$baseParams.get('view') == 'standalone') document.body.classList.add('standalone');
(0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $13c40c34b78c8ee2$export$c8a8987d4410bf2d)((0, $be839ebd791210a3$export$45f572fa777f8aba), {
    state: $38d6cc12cd11cfd3$var$GLOBAL_STATE
}), $38d6cc12cd11cfd3$var$base);


//# sourceMappingURL=abicrunch.8985dd26.js.map
